/* =====================================================================
 * Foto-Decke Collage Editor — datengetriebene Engine (Port aus collage-engine.html)
 * =====================================================================
 * Ein Editor für ALLE Decken-Layouts. `layout_id` (Section-Setting pro
 * -gestalten-Page) bestimmt das Startlayout; der Layout-Tab erlaubt Wechsel
 * zwischen allen Decken-Designs. Foto-Upload mit Crop-Modal (Cropper.js),
 * Farbwechsel, editierbare Texte. Look 1:1 aus collage-engine.html
 * (LAYOUTS-Daten + SVG-Overlay/Underlay-Builder verbatim übernommen).
 *
 * Flow:
 *   1. Layout-Tab: Picker über alle Decken-Designs → loadLayout(id).
 *   2. Foto-Tab: "Fotos hochladen" (multi) füllt leere Slots; Tap auf ein Foto
 *      in der Vorschau öffnet das Crop-Modal (Ausschnitt wählen). Sofort-Preview
 *      via objectURL, Original im Hintergrund nach S3 (/api/v1/upload/presigned-url/).
 *      Crop wird als normierte Ratios {x,y,w,h} gespeichert (Print nutzt S3-Original).
 *   3. Text-Tab: pro Layout-Text ein Eingabefeld → Live-DOM-Update.
 *   4. Produkt-Tab: Größen-Picker → Variant-ID + Preis. Deckenfarbe im Foto-Tab.
 *   5. Cart-Add: /api/v1/blanket/render/ (config_json) → /cart/add.js mit
 *      _Provider=merchone + _job_id (Server-Render Phase 3, 404 = Fallback-URL).
 * ===================================================================== */

(function () {
  'use strict';

  const BACKEND_API_URL = window.COLLAGE_POSTER_BACKEND_API_URL || 'https://tiles.distantlines.de';
  const CROPPER_CSS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.css';
  const CROPPER_JS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.js';
  const MAX_FILE_SIZE_MB = 20;
  const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];

  /* ===================================================================
   * LAYOUT-DATEN + SVG-BUILDER — VERBATIM aus collage-engine.html.
   * (Decken-Look ist hierdurch 1:1 identisch zur Engine-Vorschau.)
   * =================================================================== */
const SAMPLE = 'assets/photo-mockup-default.jpg';
const CAM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';

const LAYOUTS = [
  {
    id:'doppelrahmen', name:'Doppelrahmen', sub:'quer · 6 Fotos',
    aspect:'100/70', blanketPad:5.5, photoStyle:'plain',
    panel:{ color:'#EAE3D5', pad:3 },
    frame:{ labels:['Außen','Innen'], colors:['#CBCBCB','#EAE3D5'] },
    grid:{ cols:'1fr 1fr 1fr', rows:'1fr 1fr', gap:2.6 },
    photos:[{c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'3/4',r:'1/2'},{c:'1/2',r:'2/3'},{c:'2/3',r:'2/3'},{c:'3/4',r:'2/3'}],
    texts:[]
  },
  {
    id:'mega-papa', name:'Mega Papa', sub:'hoch · 4 Fotos + Text',
    aspect:'70/100', blanketPad:3.5, photoStyle:'mat',
    panel:null,
    grid:{ cols:'1.3fr 1fr', rows:'0.7fr 1fr 0.7fr 1fr 0.9fr 0.6fr', gap:1.8 },
    photos:[{c:'2/3',r:'1/3'},{c:'1/2',r:'2/5'},{c:'2/3',r:'4/6'},{c:'1/2',r:'5/7'}],
    texts:[
      {content:'PAPA', c:'1/2', r:'1/2', font:'Playfair Display', weight:800, size:11, color:'#7A9E55', justify:'flex-start', pad:'0 0 0 0.5cqw'},
      {content:'DU BIST', c:'2/3', r:'3/4', font:'Outfit', weight:600, size:3, color:'#28292d', justify:'center', spacing:'0.22em', upper:true},
      {content:'DER BESTE', c:'1/3', r:'6/7', font:'Playfair Display', weight:800, size:10, color:'#E07856', justify:'flex-end', pad:'0 0.5cqw 0 0'}
    ]
  },
  {
    id:'foto-grid-8', name:'Foto Grid 8', sub:'hoch · 8 Fotos',
    aspect:'70/100', blanketPad:6, photoStyle:'mat', panel:null,
    grid:{ cols:'1fr 1fr 1fr', rows:'1fr 1fr 1fr', gap:2.4 },
    photos:[{c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'3/4',r:'1/2'},{c:'1/2',r:'2/3'},{c:'3/4',r:'2/3'},{c:'1/2',r:'3/4'},{c:'2/3',r:'3/4'},{c:'3/4',r:'3/4'}],
    texts:[]
  },
  {
    id:'drei-reihen', name:'Drei Reihen', sub:'hoch · 9 Fotos + Text',
    aspect:'70/100', blanketPad:5.5, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr 1fr 1fr', rows:'auto 1fr auto 1fr auto 1fr', gap:2.4 },
    photos:[{c:'1/2',r:'2/3'},{c:'2/3',r:'2/3'},{c:'3/4',r:'2/3'},{c:'1/2',r:'4/5'},{c:'2/3',r:'4/5'},{c:'3/4',r:'4/5'},{c:'1/2',r:'6/7'},{c:'2/3',r:'6/7'},{c:'3/4',r:'6/7'}],
    texts:[
      {content:'UNSERE FAMILIE', c:'1/2', r:'1/2', font:'Outfit', weight:700, size:4, color:'#3a3a3a', justify:'flex-start', upper:true},
      {content:'MOMENTE', c:'1/2', r:'3/4', font:'Outfit', weight:700, size:4, color:'#3a3a3a', justify:'flex-start', upper:true},
      {content:'FÜR IMMER', c:'1/2', r:'5/6', font:'Outfit', weight:700, size:4, color:'#3a3a3a', justify:'flex-start', upper:true}
    ]
  },
  {
    id:'filmstrip', name:'Filmstrip', sub:'hoch · 9 Fotos schräg + Script',
    aspect:'70/100', blanketPad:0, photoStyle:'mat', panel:null, allPhotos:true, blanketColor:'#c6beb2',
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* 3 durchgehende STRIP-BALKEN — je 3 Fotos in EINEM weißen Balken (kein Spalt dazwischen, nur dünne
       weiße Trenner + ein gemeinsamer Rahmen), Balken als Einheit gekippt. */
    photos:[],
    bars:[
      {x:-5, y:4,  w:110, h:20, rot:-4, cols:3},   /* oben: edge-to-edge, schräg nach oben, etwas tiefer */
      {x:-5, y:37, w:110, h:20, rot:4,  cols:3},   /* mitte: edge-to-edge, schräg nach unten */
      {x:-5, y:60, w:110, h:20, rot:-6, cols:3}    /* unten: edge-to-edge, steiler nach oben */
    ],
    texts:[
      {content:'Kayla and James', free:true, x:50, y:31, font:'Dancing Script', weight:700, size:7, color:'#3a3a3a'},
      {content:"it's a love story", free:true, x:74, y:91, font:'Playfair Display', weight:500, size:3.2, color:'#3a3a3a', italic:true}
    ]
  },
  {
    id:'ornament', name:'Ornament Collage', sub:'quer · 7 Fotos + Text',
    aspect:'100/70', blanketPad:6, photoStyle:'plain', panel:{ color:'#E8E6E0', pad:4 },
    frame:{ labels:['Außen','Innen'], colors:['#CBCBCB','#E8E6E0'] },
    grid:{ cols:'1.25fr 0.85fr 0.85fr 1.25fr', rows:'1fr 0.55fr 0.45fr 1fr', gap:1.6 },
    photos:[{c:'1/2',r:'1/3'},{c:'2/3',r:'1/2'},{c:'3/4',r:'1/2'},{c:'4/5',r:'1/2'},{c:'2/4',r:'2/5'},{c:'1/2',r:'4/5'},{c:'4/5',r:'4/5'}],
    texts:[
      {content:'liebe + glück', c:'1/2', r:'3/4', font:'Playfair Display', weight:400, size:3.2, color:'#28292d', justify:'center'},
      {content:'Familie XY', c:'4/5', r:'2/3', font:'Playfair Display', weight:400, size:3.2, color:'#28292d', justify:'center'}
    ]
  },
  {
    id:'love-collage', name:'Love', sub:'hoch · 6 Fotos + Text',
    aspect:'70/100', blanketPad:5, photoStyle:'plain', panel:{ color:'#E9E4DA', pad:3.5 },
    frame:{ labels:['Außen','Innen'], colors:['#CBCBCB','#E9E4DA'] },
    grid:{ cols:'1.15fr 1fr', rows:'1fr 1fr 1fr 1fr 1fr 1fr', gap:2.2 },
    photos:[{c:'1/2',r:'1/3'},{c:'2/3',r:'1/2'},{c:'1/2',r:'3/5'},{c:'2/3',r:'2/4'},{c:'1/2',r:'5/7'},{c:'2/3',r:'5/7'}],
    texts:[{content:'LOVE ♥', c:'2/3', r:'4/5', font:'Outfit', weight:700, size:5.5, color:'#2b2b2b', justify:'center', upper:true}]
  },
  {
    id:'vier-grid', name:'Vierer Grid', sub:'hoch · 4 Fotos + Text',
    aspect:'70/100', blanketPad:4, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr 1fr', rows:'1fr 1fr 0.28fr', gap:1.5 },
    photos:[{c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'1/2',r:'2/3'},{c:'2/3',r:'2/3'}],
    texts:[{content:'FAMILIE XY', c:'1/3', r:'3/4', font:'Outfit', weight:600, size:3.4, color:'#a07a3a', justify:'center', upper:true}]
  },
  {
    id:'klassik', name:'Klassik', sub:'hoch · 7 Fotos + Text',
    aspect:'70/100', blanketPad:4.5, photoStyle:'plain', panel:null,
    grid:{ cols:'0.8fr 1fr 1fr 0.9fr', rows:'0.7fr 1fr 1fr 1fr 1fr 1fr 0.7fr', gap:2 },
    photos:[{c:'1/2',r:'2/3'},{c:'1/2',r:'3/4'},{c:'1/2',r:'4/5'},{c:'1/2',r:'5/6'},{c:'1/2',r:'6/7'},{c:'2/4',r:'2/5'},{c:'2/5',r:'4/7'}],
    texts:[
      {content:'DEIN TEXT', c:'2/5', r:'1/2', font:'Outfit', weight:600, size:4.5, color:'#a07a3a', justify:'center', upper:true},
      {content:'DEIN TEXT', c:'1/4', r:'7/8', font:'Outfit', weight:600, size:4.5, color:'#a07a3a', justify:'center', upper:true}
    ]
  },
  {
    id:'moon-stars', name:'Mond & Sterne', sub:'quer · Foto-Sichel + Sterne',
    aspect:'100/70', blanketPad:0, photoStyle:'mat', panel:null, allPhotos:true, blanketColor:'#2d3b54',
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* Fotos in Mondsichel-Form (vom User per Drag angeordnet); die 2 Spitzen-Fotos auf ¾ verkleinert */
    photos:[
      {x:38.3, y:12.2, w:7.4, h:10.6, rot:-6},
      {x:47.0, y:12.3, w:5.6, h:8, rot:2},
      {x:23.4, y:15.8, w:7.4, h:10.6, rot:-5},
      {x:31, y:11.3, w:7.4, h:10.6, rot:1},
      {x:34.1, y:20.3, w:7.4, h:10.6, rot:-12},
      {x:19.8, y:22.2, w:7.4, h:10.6, rot:-17},
      {x:27.7, y:25.6, w:7.4, h:10.6, rot:-14},
      {x:17.6, y:30.6, w:7.4, h:10.6, rot:-6},
      {x:25.6, y:35.1, w:7.4, h:10.6, rot:11},
      {x:12, y:40.9, w:7.4, h:10.6, rot:-8},
      {x:18.7, y:41.8, w:7.4, h:10.6, rot:-1},
      {x:23.9, y:45.8, w:7.4, h:10.6, rot:1},
      {x:15.8, y:53.7, w:7.4, h:10.6, rot:-5},
      {x:24.4, y:55.7, w:7.4, h:10.6, rot:-5},
      {x:18.1, y:64.5, w:7.4, h:10.6, rot:-13},
      {x:27, y:64.9, w:7.4, h:10.6, rot:-4},
      {x:33.1, y:68.8, w:7.4, h:10.6, rot:0},
      {x:24.6, y:73.2, w:7.4, h:10.6, rot:13},
      {x:31.8, y:78, w:7.4, h:10.6, rot:-15},
      {x:38.4, y:79.3, w:7.4, h:10.6, rot:13},
      {x:46.8, y:81.9, w:5.6, h:8, rot:3}
    ],
    underlay:{ type:'moonstars' },
    texts:[
      {content:'LOVE YOU', free:true, x:73, y:37, font:'Outfit', weight:600, size:4, color:'#eef1f7', upper:true},
      {content:'TO THE',   free:true, x:73, y:45, font:'Outfit', weight:600, size:4, color:'#eef1f7', upper:true},
      {content:'MOON',     free:true, x:73, y:53, font:'Outfit', weight:600, size:4, color:'#eef1f7', upper:true},
      {content:'AND BACK', free:true, x:73, y:61, font:'Outfit', weight:600, size:4, color:'#eef1f7', upper:true}
    ]
  },
  {
    id:'schraeg-stapel', name:'Schräg Stapel', sub:'hoch · überlappend + schräg',
    aspect:'70/100', blanketPad:0, photoStyle:'mat', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* x/y = obere-linke Ecke in %, w/h = Größe in %, rot = Grad. Überlappen via z-index (Reihenfolge). */
    photos:[
      {x:13, y:9,  w:48, h:30, rot:-7},
      {x:39, y:29, w:50, h:32, rot:6},
      {x:11, y:53, w:48, h:30, rot:-4},
      {x:41, y:69, w:46, h:27, rot:9}
    ],
    texts:[]
  },
  {
    id:'quilt-border', name:'Quilt-Bordüre', sub:'quer · 1 Foto + Deko',
    aspect:'4/3', blanketPad:0, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    photos:[{x:0, y:0, w:100, h:100, rot:0}],   /* Vollbild-Foto, Deko liegt drüber */
    overlay:{ type:'quilt-border', cream:'#efece5', colors:['#efece5'], opacity:0.8, inset:60, starSize:150 },
    texts:[
      {content:'OUR DAD',  free:true, x:24, y:78, font:'Outfit', weight:600, size:4, color:'#ffffff', upper:true},
      {content:'OUR HERO', free:true, x:76, y:78, font:'Outfit', weight:600, size:4, color:'#ffffff', upper:true}
    ]
  },
  {
    id:'best-mom', name:'Best Mom', sub:'hoch · 1 Foto + Streifen', aspect:'70/100', blanketPad:0, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0,y:0,w:100,h:100,rot:0}],
    overlay:{ type:'best-mom', colors:['#eff2f4','#bcced9'] },
    texts:[
      {content:'The',  free:true, x:74, y:14, font:'Playfair Display', weight:500, size:9,  color:'#ffffff'},
      {content:'Best', free:true, x:27, y:73, font:'Playfair Display', weight:500, size:13, color:'#ffffff'},
      {content:'Mom',  free:true, x:54, y:86, font:'Playfair Display', weight:500, size:13, color:'#ffffff'}
    ]
  },
  {
    id:'do-not-disturb', name:'Do Not Disturb', sub:'hoch · 1 Foto + Streifen', aspect:'70/100', blanketPad:0, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0,y:0,w:100,h:100,rot:0}],
    overlay:{ type:'do-not-disturb', colors:['#eef0ec','#cdd9e6'] },
    texts:[
      {content:'DO NOT DISTURB', free:true, x:50, y:7, font:'Outfit', weight:700, size:4.4, color:'#2c3e5b', upper:true},
      {content:'cuddling in progress', free:true, x:62, y:93, font:'Playfair Display', weight:500, size:3.4, color:'#2c3e5b', italic:true}
    ]
  },
  {
    id:'painted-stripes', name:'Painted Stripes', sub:'hoch · 1 Foto + Streifen', aspect:'70/100', blanketPad:0, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0,y:0,w:100,h:100,rot:0}],
    overlay:{ type:'painted-stripes', colors:['#cda9a1','#b9826a'] },
    texts:[ {content:'HOME IS WHERE YOU ARE', free:true, x:50, y:80, font:'Playfair Display', weight:500, size:2.9, color:'#5a4a42', upper:true} ]
  },
  {
    id:'cool-moms-club', name:'Cool Moms Club', sub:'hoch · 1 Foto + Karo', aspect:'70/100', blanketPad:0, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0,y:0,w:100,h:100,rot:0}],
    overlay:{ type:'cool-moms', colors:['#e8513c','#f4c9c4'] },
    texts:[ {content:'Cool Moms Club', free:true, x:50, y:83, font:'Dancing Script', weight:700, size:6, color:'#ffffff'} ]
  },
  {
    id:'heart-framed-border', name:'Heart Frame', sub:'hoch · 1 Foto + Herzen', aspect:'70/100', blanketPad:0, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0,y:0,w:100,h:100,rot:0}],
    overlay:{ type:'heart-border' },
    texts:[ {content:'Love You Most', free:true, x:50, y:84, font:'Dancing Script', weight:700, size:5.5, color:'#ffffff'} ]
  },
  {
    id:'painted-gingham', name:'Painted Gingham', sub:'hoch · 1 Foto (oval) + Karo', aspect:'70/100', blanketPad:0, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0,y:0,w:100,h:100,rot:0}],
    overlay:{ type:'painted-gingham', colors:['#f1efe6','#aebb9f'] },
    texts:[
      {content:'I LOVE YOU MAMA', free:true, x:50, y:77, font:'Playfair Display', weight:500, size:3.2, color:'#7d8b73', upper:true, spacing:'0.14em'},
      {content:'samantha', free:true, x:50, y:82, font:'Dancing Script', weight:600, size:2.8, color:'#9aa890'}
    ]
  },
  {
    id:'cozy-flannel', name:'Cozy Flannel', sub:'hoch · 3 Fotos + Plaid', aspect:'70/100', blanketPad:7.5, photoStyle:'plain',
    panel:{ color:'#f3efe9', pad:3.2 },
    grid:{ cols:'1fr 1fr', rows:'1fr 1fr 0.34fr', gap:2.4 },
    photos:[{c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'1/3',r:'2/3'}],
    underlay:{ type:'plaid' },
    texts:[ {content:'THE SINCLAIRE FAMILY', c:'1/3', r:'3/4', font:'Playfair Display', weight:500, size:2.9, color:'#5a5550', justify:'center', upper:true} ]
  },
  {
    id:'pinstripe-love-story', name:'Pinstripe Love Story', sub:'hoch · 4 Fotos + Pinstripes', aspect:'70/100', blanketPad:6, photoStyle:'plain', panel:null,
    grid:{ cols:'1fr 1fr', rows:'1fr 1fr', gap:2.2 },
    photos:[{c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'1/2',r:'2/3'},{c:'2/3',r:'2/3'}],
    underlay:{ type:'pinstripe', colors:['#ffffff','#1b1b1b'] },
    texts:[
      {content:'♥', free:true, x:12, y:10, font:'Outfit', weight:700, size:3.2, color:'#d12b2b'},
      {content:"IT'S A LOVE STORY", free:true, x:36, y:10, font:'Outfit', weight:600, size:2.7, color:'#222222', upper:true},
      {content:'KIMBERLY +JOSHUA', free:true, x:68, y:92, font:'Outfit', weight:600, size:2.3, color:'#222222', upper:true}
    ]
  },
  {
    id:'colorblock-collage', name:'Colorblock Collage', sub:'hoch · 4 Fotos + Blöcke', aspect:'70/100',
    blanketPad:0, photoStyle:'plain', panel:null, allPhotos:true,
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* je ein Foto pro Farbblock (2×2), Caption darunter */
    photos:[
      {x:10, y:8,  w:30, h:31, rot:0},
      {x:60, y:8,  w:30, h:31, rot:0},
      {x:10, y:58, w:30, h:31, rot:0},
      {x:60, y:58, w:30, h:31, rot:0}
    ],
    underlay:{ type:'colorblocks' },
    texts:[
      {content:'2024', free:true, x:25, y:43, font:'Playfair Display', weight:500, size:2.4, color:'#8a8276', italic:true},
      {content:'2024', free:true, x:75, y:43, font:'Playfair Display', weight:500, size:2.4, color:'#8a8276', italic:true},
      {content:'2024', free:true, x:25, y:93, font:'Playfair Display', weight:500, size:2.4, color:'#8a8276', italic:true},
      {content:'2024', free:true, x:75, y:93, font:'Playfair Display', weight:500, size:2.4, color:'#8a8276', italic:true}
    ]
  },
  {
    id:'family-quer', name:'Family Is Everything (quer)', sub:'quer · 8 Fotos + Text', aspect:'100/70',
    blanketPad:3, photoStyle:'plain', panel:null, allPhotos:true, blanketColor:'#2a2a2a',
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* frei: Ecken voll-hoch (h30); oben/unten-Mittelfoto KÜRZER (h23, oben- bzw. unten-bündig, gleiche Breite); Mittelreihe schmale Seiten; Mitte = Text-Panel (Decken-Farbe). Draggable. */
    photos:[
      {x:3,  y:3,  w:30, h:30, rot:0},
      {x:35, y:3,  w:30, h:23, rot:0},
      {x:67, y:3,  w:30, h:30, rot:0},
      {x:3,  y:35, w:25, h:30, rot:0},
      {x:72, y:35, w:25, h:30, rot:0},
      {x:3,  y:67, w:30, h:30, rot:0},
      {x:35, y:74, w:30, h:23, rot:0},
      {x:67, y:67, w:30, h:30, rot:0}
    ],
    texts:[
      {content:'FAMILY IS',    free:true, x:50, y:41, font:'Playfair Display', weight:500, size:3.4, color:'#ffffff', upper:true, spacing:'0.18em'},
      {content:'everything',   free:true, x:50, y:49, font:'Dancing Script', weight:600, size:5.5, color:'#ffffff'},
      {content:'♥',            free:true, x:50, y:56, font:'Outfit', weight:700, size:1.9, color:'#e3a7ad'},
      {content:'THE STEWARTS', free:true, x:50, y:61, font:'Outfit', weight:500, size:1.9, color:'#ffffff', upper:true, spacing:'0.16em'}
    ]
  },
  {
    id:'family-hoch', name:'Family', sub:'hoch · 8 Fotos + Text', aspect:'70/100',
    blanketPad:3, photoStyle:'plain', panel:null, allPhotos:true, blanketColor:'#efece4',
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* frei: Ecken voll-hoch (h30); oben/unten-Mittelfoto KÜRZER (h23, oben- bzw. unten-bündig, gleiche Breite); Mittelreihe schmale Seiten; Mitte = Text-Panel. Draggable. */
    photos:[
      {x:3,  y:3,  w:30, h:30, rot:0},
      {x:35, y:3,  w:30, h:23, rot:0},
      {x:67, y:3,  w:30, h:30, rot:0},
      {x:3,  y:35, w:25, h:30, rot:0},
      {x:72, y:35, w:25, h:30, rot:0},
      {x:3,  y:67, w:30, h:30, rot:0},
      {x:35, y:74, w:30, h:23, rot:0},
      {x:67, y:67, w:30, h:30, rot:0}
    ],
    texts:[
      {content:'FAMILY IS',    free:true, x:50, y:43, font:'Playfair Display', weight:500, size:3.2, color:'#3a3a3a', upper:true, spacing:'0.18em'},
      {content:'everything',   free:true, x:50, y:49, font:'Dancing Script', weight:600, size:5, color:'#3a3a3a'},
      {content:'♥',            free:true, x:50, y:54, font:'Outfit', weight:700, size:1.8, color:'#cf9aa2'},
      {content:'THE STEWARTS', free:true, x:50, y:59, font:'Outfit', weight:500, size:1.8, color:'#3a3a3a', upper:true, spacing:'0.16em'}
    ]
  },
  {
    id:'heart-collage', name:'Herz Collage', sub:'hoch · 12 Fotos Herz + Name', aspect:'70/100',
    blanketPad:3, photoStyle:'mat', allPhotos:true, blanketColor:'#efe9dd',
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* frei: 15 gekippte Polaroids, MIX Hoch-(16x15) / Quer-(22x14) / Quadrat-(17x13) — Quer vergrößert, damit gleich groß wie Hoch wirkt. Zentren = Dominiks Drag-Anordnung (2026-05-31). Draggable. */
    photos:[
      {x:35.7, y:28.2, w:16, h:15, rot:6},
      {x:27.7, y:17.2, w:22, h:14, rot:-6},
      {x:10.6, y:12.2, w:22, h:14, rot:-10},
      {x:46.6, y:15.7, w:16, h:15, rot:10},
      {x:6.5,  y:24.8, w:16, h:15, rot:-14},
      {x:17.6, y:24.8, w:22, h:14, rot:-3},
      {x:42.5, y:40.5, w:17, h:13, rot:5},
      {x:68.2, y:26.1, w:16, h:15, rot:-5},
      {x:50.4, y:26.1, w:22, h:14, rot:13},
      {x:18.3, y:37.9, w:22, h:14, rot:9},
      {x:58.2, y:36.2, w:16, h:15, rot:-8},
      {x:59.7, y:11.7, w:22, h:14, rot:7},
      {x:32,   y:47.5, w:16, h:15, rot:-9},
      {x:47,   y:49,   w:22, h:14, rot:8},
      {x:40.5, y:57.5, w:17, h:13, rot:4}
    ],
    texts:[
      {content:'THE WATSONS', free:true, x:50, y:80, font:'Outfit', weight:500, size:2.3, color:'#3a3a3a', upper:true, spacing:'0.22em'}
    ]
  },

  /* ========================================================================
   * KISSEN / PREMIUM PILLOW — quadratisch (1:1). MerchOne Blueprint 31.
   * Print 3543/4724/7087 px @300dpi (30/40/60cm), Safe-Zone 7,5mm/Seite.
   * Vorlagen: Shutterfly-Kissen (~/Desktop/Kissen Layouts/specs/).
   * ===================================================================== */
  {
    id:'heart-collage-pillow', name:'Tilted Heart Collage (Kissen)', sub:'1:1 · 23 Fotos Herz + Name', aspect:'1/1',
    blanketPad:0, photoStyle:'mat', allPhotos:true, blanketColor:'#1c3e60',
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    /* frei: 23 gekippte Polaroids, dichtes Herz (1:1). Draggable. */
    photos:[
      {x:23.5, y:7.0,  w:13, h:16, rot:-10},
      {x:33.0, y:5.5,  w:16, h:13, rot:6},
      {x:51.0, y:5.5,  w:16, h:13, rot:-6},
      {x:63.5, y:7.0,  w:13, h:16, rot:10},
      {x:10.5, y:19.0, w:13, h:16, rot:-14},
      {x:22.0, y:17.5, w:16, h:13, rot:-4},
      {x:35.5, y:16.5, w:15, h:15, rot:5},
      {x:49.5, y:16.5, w:15, h:15, rot:-5},
      {x:62.0, y:17.5, w:16, h:13, rot:4},
      {x:76.5, y:19.0, w:13, h:16, rot:13},
      {x:15.0, y:30.5, w:16, h:13, rot:-9},
      {x:30.5, y:30.0, w:13, h:16, rot:7},
      {x:42.0, y:31.5, w:16, h:13, rot:-6},
      {x:56.5, y:30.0, w:13, h:16, rot:6},
      {x:69.0, y:30.5, w:16, h:13, rot:10},
      {x:24.5, y:41.0, w:13, h:16, rot:-8},
      {x:37.0, y:43.5, w:16, h:13, rot:6},
      {x:51.5, y:42.0, w:13, h:16, rot:-7},
      {x:62.0, y:41.5, w:16, h:13, rot:8},
      {x:32.5, y:51.0, w:13, h:16, rot:-9},
      {x:44.0, y:53.5, w:16, h:13, rot:7},
      {x:57.5, y:50.0, w:13, h:16, rot:9},
      {x:41.5, y:60.5, w:15, h:15, rot:4}
    ],
    texts:[
      {content:'THE HILLER FAMILY', free:true, x:50, y:88, font:'Outfit', weight:400, size:2.2, color:'#b9c5d6', upper:true, spacing:'0.34em'}
    ]
  },
  {
    id:'classic-heart-frame-pillow', name:'Classic Heart Frame (Kissen)', sub:'1:1 · 1 Foto gerahmt + Herz + Text', aspect:'1/1',
    blanketPad:0, photoStyle:'mat', allPhotos:true, blanketColor:'#eaeaea',
    grid:{ cols:'1fr', rows:'1fr', gap:0 },
    photos:[{x:9, y:6, w:82, h:64, rot:0}],
    texts:[
      {content:'♥',                free:true, x:50, y:79, font:'Outfit', weight:700, size:2.3, color:'#d98a9a'},
      {content:'WE LOVE YOU NANA', free:true, x:50, y:85, font:'Outfit', weight:500, size:2.5, color:'#4a4a4a', upper:true, spacing:'0.2em'},
      {content:'GRACE • BELLA',    free:true, x:50, y:90, font:'Outfit', weight:500, size:1.5, color:'#8a8a8a', upper:true, spacing:'0.18em'}
    ]
  },
  {
    id:'whimsy-heart-border-pillow', name:'Whimsy Heart Border (Kissen)', sub:'1:1 · Vollfoto + Doodle-Rand', aspect:'1/1',
    blanketPad:0, photoStyle:'plain', allPhotos:true,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0, y:0, w:100, h:100, rot:0}],
    overlay:{ type:'whimsy-heart-border' },
    texts:[
      {content:'Love, always', free:true, x:73, y:89, font:'Dancing Script', weight:600, size:3.2, color:'#ffffff'}
    ]
  },
  {
    id:'gallery-of-nine-pillow', name:'Gallery of Nine (Kissen)', sub:'1:1 · 9 Fotos Grid', aspect:'1/1',
    blanketPad:2.2, photoStyle:'plain', allPhotos:true, blanketColor:'#f3f3f3',
    grid:{ cols:'1fr 1fr 1fr', rows:'1fr 1fr 1fr', gap:2.2 },
    photos:[{c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'3/4',r:'1/2'},{c:'1/2',r:'2/3'},{c:'2/3',r:'2/3'},{c:'3/4',r:'2/3'},{c:'1/2',r:'3/4'},{c:'2/3',r:'3/4'},{c:'3/4',r:'3/4'}],
    texts:[]
  },
  {
    id:'grid-gallery-of-four-pillow', name:'Grid Gallery of Four (Kissen)', sub:'1:1 · 4 Fotos + Fischgrät-BG', aspect:'1/1',
    blanketPad:6, photoStyle:'plain', allPhotos:true, blanketColor:'#d6d6d6',
    grid:{ cols:'1fr 1fr', rows:'1fr 1fr', gap:5 },
    photos:[{c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'1/2',r:'2/3'},{c:'2/3',r:'2/3'}],
    texts:[]
  },
  {
    id:'we-heart-montage-pillow', name:'We Heart Montage (Kissen)', sub:'1:1 · 8 Fotos + Spruch (schwarz)', aspect:'1/1',
    blanketPad:3, photoStyle:'plain', allPhotos:true, blanketColor:'#111111',
    grid:{ cols:'1fr 1fr 1fr', rows:'1.1fr 0.5fr 1fr 1fr', gap:2.4 },
    photos:[
      {c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'3/4',r:'1/2'},
      {c:'1/2',r:'3/4'},{c:'1/2',r:'4/5'},
      {c:'2/3',r:'3/5'},
      {c:'3/4',r:'3/4'},{c:'3/4',r:'4/5'}
    ],
    texts:[
      {content:'we ♥ gigi and papa', c:'1/4', r:'2/3', font:'Playfair Display', weight:400, size:4, color:'#ffffff', justify:'center'}
    ]
  },
  {
    id:'family-gallery-seven-pillow', name:'Family Gallery of Seven (Kissen)', sub:'1:1 · 7 Fotos + FAMILY/LOVE/HUGS', aspect:'1/1',
    blanketPad:3, photoStyle:'plain', allPhotos:true, blanketColor:'#111111',
    grid:{ cols:'1fr 1fr 1fr', rows:'1fr 1fr 1fr 1fr', gap:2.4 },
    photos:[
      {c:'1/2',r:'1/2'},{c:'2/4',r:'1/2'},
      {c:'2/3',r:'2/3'},{c:'3/4',r:'2/4'},
      {c:'1/2',r:'3/4'},
      {c:'1/2',r:'4/5'},{c:'2/3',r:'4/5'}
    ],
    texts:[
      {content:'FAMILY', c:'1/2', r:'2/3', font:'Playfair Display', weight:500, size:3.4, color:'#ffffff', justify:'center', spacing:'0.12em', upper:true},
      {content:'LOVE',   c:'2/3', r:'3/4', font:'Playfair Display', weight:500, size:3.4, color:'#ffffff', justify:'center', spacing:'0.14em', upper:true},
      {content:'HUGS',   c:'3/4', r:'4/5', font:'Playfair Display', weight:500, size:3.4, color:'#ffffff', justify:'center', spacing:'0.14em', upper:true}
    ]
  },
  {
    id:'modern-love-collage-pillow', name:'Modern Love Collage (Kissen)', sub:'1:1 · 10 Fotos + ♥LOVE', aspect:'1/1',
    blanketPad:2, photoStyle:'plain', allPhotos:true, blanketColor:'#f4f4f4',
    grid:{ cols:'1fr 1fr 1fr', rows:'1fr 1fr 1fr 1fr', gap:2 },
    photos:[
      {c:'1/2',r:'1/2'},{c:'2/3',r:'1/2'},{c:'3/4',r:'1/2'},
      {c:'1/2',r:'2/3'},{c:'2/3',r:'2/4'},{c:'3/4',r:'2/3'},
      {c:'1/2',r:'3/4'},
      {c:'1/2',r:'4/5'},{c:'2/3',r:'4/5'},{c:'3/4',r:'4/5'}
    ],
    texts:[
      {content:'♥ LOVE', c:'3/4', r:'3/4', font:'Outfit', weight:700, size:2.6, color:'#28292d', justify:'center'}
    ]
  },
  {
    id:'photo-gallery-pillow', name:'Photo Gallery (Kissen)', sub:'1:1 · Vollfoto + Name', aspect:'1/1',
    blanketPad:0, photoStyle:'plain', allPhotos:true,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0, y:0, w:100, h:100, rot:0}],
    texts:[
      {content:'THE HUGHES', free:true, x:50, y:91, font:'Outfit', weight:600, size:3.4, color:'#ffffff', upper:true, spacing:'0.18em'}
    ]
  },
  {
    id:'watercolor-border-pillow', name:'Watercolor Border (Kissen)', sub:'1:1 · Foto + Aquarell-Rand', aspect:'1/1',
    blanketPad:0, photoStyle:'mat', allPhotos:true, blanketColor:'#eef0f0',
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:10, y:10, w:80, h:80, rot:0}],
    texts:[]
  },
  {
    id:'minimalist-heart-film-pillow', name:'Minimalist Heart Film (Kissen)', sub:'1:1 · Foto + Doodle-Herz + Text', aspect:'1/1',
    blanketPad:0, photoStyle:'mat', allPhotos:true, blanketColor:'#e9e9e9',
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:13, y:11, w:74, h:64, rot:0}],
    overlay:{ type:'heart-film-doodle' },
    texts:[
      {content:'your text here', free:true, x:73, y:88, font:'Dancing Script', weight:500, size:2.8, color:'#2c3550'}
    ]
  },
  {
    id:'love-paw-pillow', name:'Love Paw (Kissen)', sub:'1:1 · Vollfoto + L🐾VE + Name', aspect:'1/1',
    blanketPad:0, photoStyle:'plain', allPhotos:true,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:0, y:0, w:100, h:100, rot:0}],
    overlay:{ type:'love-paw' },
    texts:[
      {content:'L',  free:true, x:41,   y:83, font:'Playfair Display', weight:600, size:6.5, color:'#ffffff'},
      {content:'VE', free:true, x:57.5, y:83, font:'Playfair Display', weight:600, size:6.5, color:'#ffffff'},
      {content:'BUSTER 2008 - 2022', free:true, x:50, y:92, font:'Outfit', weight:500, size:1.6, color:'#ffffff', upper:true, spacing:'0.2em'}
    ]
  },
  {
    id:'neutral-foliage-frame-pillow', name:'Neutral Foliage Frame (Kissen)', sub:'1:1 · Foto + Botanik-Rand', aspect:'1/1',
    blanketPad:0, photoStyle:'mat', allPhotos:true,
    grid:{ cols:'1fr', rows:'1fr', gap:0 }, photos:[{x:13, y:11, w:74, h:70, rot:0}],
    underlay:{ type:'foliage' },
    texts:[
      {content:'BEST MOM EVER', free:true, x:50, y:76, font:'Playfair Display', weight:500, size:2.3, color:'#ffffff', upper:true, spacing:'0.14em'}
    ]
  }
];

const BLANKET_COLORS = ['#FFFFFF','#CBCBCB','#EDE7DA','#C7D8DA','#2E3A45','#8A9A7B','#C98B7A','#3F5A6B','#EAD7C2','#4A4A4A','#B9C6C9','#D9B8C4'];

/* ============================================================
 * DEKO-OVERLAY-GENERATOREN — aus Claude Design übernommen (Handoff to Claude Code).
 * Quilt-Bordüre (korrigiert): OPAKES Creme-Patchwork-Band mit 8-zackigen Sterne-FENSTERN
 * (transparent ausgestanzt) — das Foto scheint durch jeden Stern. Mitte ebenfalls transparent.
 * ============================================================ */
function buildQuiltBorderSVG(opts) {
  const NS = 'http://www.w3.org/2000/svg';
  const W = 1600, H = 1200;
  const cream = (opts.colors && opts.colors[0]) || opts.cream || '#efece5';
  const opacity = (opts.opacity != null ? opts.opacity : 0.8);
  const M = (opts.inset != null ? opts.inset : 60);        // Foto-Rand außen (eingerückt, px)
  const s = (opts.starSize != null ? opts.starSize : 150); // Sternblock-Größe (px) — kleiner = mehr Sterne
  const bd = s;                                            // Bandtiefe = ein Stern hoch
  const c = M + s / 2;                                     // Stern-Mittelpunkt-Abstand vom Decken-Rand

  // 8-zackiger Sawtooth-Stern (200×200 Block) — wird als LOCH ausgestanzt
  const STAR_PATH = 'M 100 3 L 123 44.6 L 179.2 20.8 L 155.4 77 L 197 100 L 155.4 123 '
    + 'L 179.2 179.2 L 123 155.4 L 100 197 L 77 155.4 L 20.8 179.2 L 44.6 123 '
    + 'L 3 100 L 44.6 77 L 20.8 20.8 L 77 44.6 Z';

  // gleichmäßig verteilte Stern-Mittelpunkte auf dem eingerückten Rahmen
  function lin(a, b, n) { const out = []; for (let i = 0; i < n; i++) out.push(a + (b - a) * i / (n - 1)); return out; }
  const nx = Math.max(2, Math.round((W - 2 * c) / s) + 1);
  const ny = Math.max(2, Math.round((H - 2 * c) / s) + 1);
  const xs = lin(c, W - c, nx), ys = lin(c, H - c, ny);
  const centers = [];
  xs.forEach(function (x) { centers.push([x, ys[0]]); centers.push([x, ys[ny - 1]]); });               // oben + unten (inkl. Ecken)
  for (let j = 1; j < ny - 1; j++) { centers.push([xs[0], ys[j]]); centers.push([xs[nx - 1], ys[j]]); } // links + rechts

  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
  const defs = document.createElementNS(NS, 'defs');

  // Stern als schwarze Form = Loch in der Maske
  const _qbUid = ++_svgIdSeq, _qbStar = 'qb-star-hole-' + _qbUid, _qbMask = 'qb-mask-' + _qbUid;
  const sym = document.createElementNS(NS, 'symbol');
  sym.setAttribute('id', _qbStar);
  sym.setAttribute('viewBox', '0 0 200 200');
  const sp = document.createElementNS(NS, 'path');
  sp.setAttribute('d', STAR_PATH); sp.setAttribute('fill', 'black');
  sym.appendChild(sp);
  defs.appendChild(sym);

  // Maske: weißer Ring (eingerückt um M, Tiefe bd) = Creme; Außenrand + Mitte + Sterne = transparent
  const mask = document.createElementNS(NS, 'mask');
  mask.setAttribute('id', _qbMask);
  mask.setAttribute('maskUnits', 'userSpaceOnUse');
  mask.setAttribute('x', 0); mask.setAttribute('y', 0);
  mask.setAttribute('width', W); mask.setAttribute('height', H);
  const ring = document.createElementNS(NS, 'rect');          // äußere Bandkante (um M eingerückt)
  ring.setAttribute('x', M); ring.setAttribute('y', M);
  ring.setAttribute('width', W - 2 * M); ring.setAttribute('height', H - 2 * M); ring.setAttribute('fill', 'white');
  mask.appendChild(ring);
  const inner = document.createElementNS(NS, 'rect');         // Mitte öffnen
  inner.setAttribute('x', M + bd); inner.setAttribute('y', M + bd);
  inner.setAttribute('width', W - 2 * (M + bd)); inner.setAttribute('height', H - 2 * (M + bd)); inner.setAttribute('fill', 'black');
  mask.appendChild(inner);
  centers.forEach(function (p) {                              // Stern-Fenster ausstanzen
    const u = document.createElementNS(NS, 'use');
    u.setAttribute('href', '#' + _qbStar);
    u.setAttribute('x', p[0] - s / 2); u.setAttribute('y', p[1] - s / 2);
    u.setAttribute('width', s); u.setAttribute('height', s);
    mask.appendChild(u);
  });
  defs.appendChild(mask);
  svg.appendChild(defs);

  // Creme-Patchwork-Band, durch die Maske ausgestanzt
  const band = document.createElementNS(NS, 'rect');
  band.setAttribute('x', 0); band.setAttribute('y', 0);
  band.setAttribute('width', W); band.setAttribute('height', H);
  band.setAttribute('fill', cream);
  band.setAttribute('fill-opacity', opacity);
  band.setAttribute('mask', 'url(#' + _qbMask + ')');
  svg.appendChild(band);

  return svg;
}

/* ============================================================
 * GEOMETRISCHE MUSTER-OVERLAYS (direkt gebaut — kein Claude Design).
 * SVG-Helfer + ein Builder je Decke. Portrait-Canvas 700×1000 (= 70/100).
 * ============================================================ */
const _NS = 'http://www.w3.org/2000/svg';
function _el(tag, attrs) { const e = document.createElementNS(_NS, tag); for (const k in attrs) e.setAttribute(k, attrs[k]); return e; }
function _svgRoot(w, h) { return _el('svg', { viewBox: '0 0 ' + w + ' ' + h, preserveAspectRatio: 'none' }); }
const W7 = 700, H10 = 1000;

/* Alle Muster SYMMETRISCH um die Mitte → linker Rand = rechter Rand (ungerade Anzahl bzw. Spiegelung). */
function patStripesV(g, w, h, a, b, approxSw) {
  let n = Math.max(3, Math.round(w / approxSw)); if (n % 2 === 0) n++;   // ungerade → Basis a an beiden Rändern
  const sw = w / n;
  g.appendChild(_el('rect', { x:0, y:0, width:w, height:h, fill:a }));
  for (let i = 1; i < n; i += 2) g.appendChild(_el('rect', { x:i * sw, y:0, width:sw, height:h, fill:b }));
}
function patChecker(g, w, h, a, b, approxSz) {
  let nx = Math.max(3, Math.round(w / approxSz)); if (nx % 2 === 0) nx++;
  let ny = Math.max(3, Math.round(h / approxSz)); if (ny % 2 === 0) ny++;
  const sx = w / nx, sy = h / ny;
  g.appendChild(_el('rect', { x:0, y:0, width:w, height:h, fill:a }));
  for (let j = 0; j < ny; j++) for (let i = 0; i < nx; i++)
    if ((i + j) % 2) g.appendChild(_el('rect', { x:i * sx, y:j * sy, width:sx, height:sy, fill:b }));
}
function patGingham(g, w, h, base, line, approxStep) {
  let nx = Math.max(3, Math.round(w / approxStep)); if (nx % 2 === 0) nx++;
  let ny = Math.max(3, Math.round(h / approxStep)); if (ny % 2 === 0) ny++;
  const sx = w / nx, sy = h / ny;
  g.appendChild(_el('rect', { x:0, y:0, width:w, height:h, fill:base }));
  for (let i = 1; i < nx; i += 2) g.appendChild(_el('rect', { x:i * sx, y:0, width:sx, height:h, fill:line, 'fill-opacity':0.5 }));
  for (let j = 1; j < ny; j += 2) g.appendChild(_el('rect', { x:0, y:j * sy, width:w, height:sy, fill:line, 'fill-opacity':0.5 }));
}
function patPlaid(g, w, h, base, bands) {
  g.appendChild(_el('rect', { x:0, y:0, width:w, height:h, fill:base }));
  function lay(len, draw) {                 // von der Mitte aus nach beiden Seiten gespiegelt
    const c = len / 2;
    let pos = 0, idx = 0;
    while (pos < c) {
      const band = bands[idx % bands.length];
      if (band.c !== 'none') {
        draw(c + pos, band.w, band.c, band.op);
        draw(c - pos - band.w, band.w, band.c, band.op);
      }
      pos += band.w; idx++;
    }
  }
  lay(w, function (p, bw, col, op) { g.appendChild(_el('rect', { x:p, y:0, width:bw, height:h, fill:col, 'fill-opacity':(op != null ? op : 0.5) })); });
  lay(h, function (p, bw, col, op) { g.appendChild(_el('rect', { x:0, y:p, width:w, height:bw, fill:col, 'fill-opacity':(op != null ? op : 0.5) })); });
}
function _heart(cx, cy, sz, fill) {
  const s = sz / 100;
  return _el('path', { d:'M50,84 C50,84 14,58 14,35 C14,21 25,13 36,13 C44,13 48,19 50,25 C52,19 56,13 64,13 C75,13 86,21 86,35 C86,58 50,84 50,84 Z',
    fill:fill, transform:'translate(' + (cx - 50 * s) + ',' + (cy - 50 * s) + ') scale(' + s + ')' });
}
function _star(cx, cy, r, fill) {
  let d = '';
  for (let i = 0; i < 10; i++) {
    const a = -Math.PI / 2 + i * Math.PI / 5;
    const rr = (i % 2 === 0) ? r : r * 0.42;
    d += (i === 0 ? 'M' : 'L') + (cx + rr * Math.cos(a)).toFixed(1) + ' ' + (cy + rr * Math.sin(a)).toFixed(1) + ' ';
  }
  return _el('path', { d: d + 'Z', fill: fill });
}
/* Overlay mit transparenten Foto-Fenstern (Maske). windows:[{shape,x,y,w,h,(rx)}] */
// Eindeutige SVG-IDs: mehrere Overlay-SVGs (Picker-Thumbnails + große Vorschau)
// dürfen NICHT dieselbe Masken-ID teilen, sonst greift url(#id) die ERSTE im
// DOM → falsches (kleineres) Foto-Fenster. Ursache des „Fotos kleiner"-Bugs.
let _svgIdSeq = 0;
function _overlayWindows(w, h, draw, windows) {
  const svg = _svgRoot(w, h);
  const maskId = 'ov-mask-' + (++_svgIdSeq);
  const defs = _el('defs', {});
  const mask = _el('mask', { id:maskId, maskUnits:'userSpaceOnUse', x:0, y:0, width:w, height:h });
  mask.appendChild(_el('rect', { x:0, y:0, width:w, height:h, fill:'white' }));
  (windows || []).forEach(function (win) {
    mask.appendChild(win.shape === 'ellipse'
      ? _el('ellipse', { cx:win.x + win.w / 2, cy:win.y + win.h / 2, rx:win.w / 2, ry:win.h / 2, fill:'black' })
      : _el('rect', { x:win.x, y:win.y, width:win.w, height:win.h, rx:(win.rx || 0), fill:'black' }));
  });
  defs.appendChild(mask); svg.appendChild(defs);
  const g = _el('g', { mask:'url(#' + maskId + ')' });
  draw(g);
  svg.appendChild(g);
  return svg;
}

/* === Case A: Vollbild-Foto + Overlay (Muster + Panel/Mat + Fenster) === */
function buildBestMom(overlay) {
  const win = { shape:'rect', x:101, y:122, w:500, h:618 };
  const c = (overlay && overlay.colors) || ['#eff2f4', '#bcced9'];   // [Streifen a, Streifen b] — kundenwählbar
  return _overlayWindows(W7, H10, function (g) {
    patStripesV(g, W7, H10, c[0], c[1], 56);   // Default hellblau-weiß, breite Streifen (~13)
    g.appendChild(_el('rect', { x:win.x - 14, y:win.y - 14, width:win.w + 28, height:win.h + 28, fill:'#fcfdfd' }));  // weißer Foto-Rand
  }, [win]);
}
function buildDoNotDisturb(overlay) {
  const navy = '#2c3e5b', win = { shape:'rect', x:80, y:122, w:540, h:700 };
  const c = (overlay && overlay.colors) || ['#eef0ec', '#cdd9e6'];   // [Streifen a, Streifen b] — kundenwählbar
  const svg = _overlayWindows(W7, H10, function (g) { patStripesV(g, W7, H10, c[0], c[1], 80); }, [win]);  // breite Streifen (~9)
  svg.appendChild(_el('rect', { x:win.x - 12, y:win.y - 12, width:win.w + 24, height:win.h + 24, fill:'none', stroke:navy, 'stroke-width':4 }));  // einzelne Navy-Rahmenlinie
  return svg;
}
function buildPaintedStripes(overlay) {
  const win = { shape:'rect', x:98, y:116, w:504, h:648 };
  const c = (overlay && overlay.colors) || ['#cda9a1', '#b9826a'];   // [Streifen a, Streifen b] — kundenwählbar
  return _overlayWindows(W7, H10, function (g) {
    patStripesV(g, W7, H10, c[0], c[1], 46);
    g.appendChild(_el('rect', { x:58, y:74, width:584, height:852, fill:'#fbfaf8' }));
  }, [win]);
}
function buildCoolMoms(overlay) {
  const win = { shape:'rect', x:90, y:104, w:520, h:796 };   // eckig, rundum gleich dicker Mat (30px)
  const c = (overlay && overlay.colors) || ['#e8513c', '#f4c9c4'];   // [Karo a, Karo b] — kundenwählbar
  return _overlayWindows(W7, H10, function (g) {
    patChecker(g, W7, H10, c[0], c[1], 80);                                     // gröberes Karo (~9 Spalten)
    g.appendChild(_el('rect', { x:60, y:74, width:580, height:856, fill:'#fbfbfb' }));    // Panel/Mat WEISS, eckig
  }, [win]);
}
function buildHeartBorder() {
  const sz = 100, win = { shape:'rect', x:100, y:100, w:500, h:800 };
  const pink = '#e3b7b2', cream = '#f4ece7', hT = '#c16a57', hC = '#f7efe9';
  const svg = _overlayWindows(W7, H10, function (g) {
    for (let y = 0; y < H10; y += sz) for (let x = 0; x < W7; x += sz) {
      const even = (Math.round(x / sz) + Math.round(y / sz)) % 2 === 0;
      g.appendChild(_el('rect', { x:x, y:y, width:sz, height:sz, fill:even ? cream : pink }));
      g.appendChild(_heart(x + sz / 2, y + sz / 2, sz * 0.58, even ? hT : hC));
    }
  }, [win]);
  svg.appendChild(_el('rect', { x:win.x, y:win.y, width:win.w, height:win.h, fill:'none', stroke:hT, 'stroke-width':6 }));
  return svg;
}
function buildPaintedGingham(overlay) {
  const win = { shape:'ellipse', x:106, y:112, w:488, h:592 };                          // großes Oval, füllt fast das Panel
  const c = (overlay && overlay.colors) || ['#f1efe6', '#aebb9f'];   // [Gingham Grund, Linie] — kundenwählbar
  return _overlayWindows(W7, H10, function (g) {
    patGingham(g, W7, H10, c[0], c[1], 46);
    g.appendChild(_el('rect', { x:56, y:56, width:588, height:888, rx:50, fill:'#f4f1ea' }));  // schmaler Gingham-Rand (~8%), gerundet
  }, [win]);
}

/* === Case B: Muster-Underlay (hinter den Grid-Fotos) === */
function buildPlaidUnderlay() {
  const svg = _svgRoot(W7, H10), g = _el('g', {});
  // großes Buffalo-Plaid: heller Taupe-Grund + breite Grau-Grün- + Mauve-Bänder (chunkige Blöcke)
  patPlaid(g, W7, H10, '#b3a895', [{ c:'none', w:80 }, { c:'#7e8470', w:72, op:0.5 }, { c:'none', w:28 }, { c:'#9c8278', w:40, op:0.4 }]);
  svg.appendChild(g); return svg;
}
function buildPinstripeUnderlay(opts) {
  const col = (opts && opts.colors) || ['#ffffff', '#1b1b1b'];   // [Hintergrund, Linie] — kundenwählbar
  const svg = _svgRoot(W7, H10);
  svg.appendChild(_el('rect', { x:0, y:0, width:W7, height:H10, fill:col[0] }));
  // Linien-Paare gleichmäßig über die GANZE Breite (volle Höhe, hinter den Fotos), symmetrisch um die Mitte
  const period = 64, c = W7 / 2;
  function pair(pc) {
    svg.appendChild(_el('rect', { x:pc - 4, y:0, width:2, height:H10, fill:col[1] }));
    svg.appendChild(_el('rect', { x:pc + 4, y:0, width:2, height:H10, fill:col[1] }));
  }
  pair(c);
  for (let off = period; c - off > 4; off += period) { pair(c - off); pair(c + off); }
  return svg;
}

/* === Kissen: Whimsy Heart Border — dünner weißer Doodle-Rahmen + 2 Herz-Outlines unten links (1:1) === */
function buildWhimsyHeartBorder() {
  const S = 1000, m = 55;
  const svg = _svgRoot(S, S);
  svg.appendChild(_el('rect', { x:m, y:m, width:S - 2 * m, height:S - 2 * m, rx:38, fill:'none', stroke:'#ffffff', 'stroke-width':3.5, opacity:0.92 }));
  function heartOutline(cx, cy, sz) {
    const s = sz / 100;
    return _el('path', { d:'M50,84 C50,84 14,58 14,35 C14,21 25,13 36,13 C44,13 48,19 50,25 C52,19 56,13 64,13 C75,13 86,21 86,35 C86,58 50,84 50,84 Z',
      fill:'none', stroke:'#ffffff', 'stroke-width':(3.5 / s).toFixed(2), opacity:0.92,
      transform:'translate(' + (cx - 50 * s) + ',' + (cy - 50 * s) + ') scale(' + s + ')' });
  }
  svg.appendChild(heartOutline(120, 882, 74));
  svg.appendChild(heartOutline(192, 906, 52));
  return svg;
}

/* === Kissen: Minimalist Heart Film — navy Doodle-Herz oben links (1:1) === */
function buildHeartFilmDoodle() {
  const S = 1000, s = 1.55;
  const svg = _svgRoot(S, S);
  svg.appendChild(_el('path', { d:'M50,84 C50,84 14,58 14,35 C14,21 25,13 36,13 C44,13 48,19 50,25 C52,19 56,13 64,13 C75,13 86,21 86,35 C86,58 50,84 50,84 Z',
    fill:'none', stroke:'#26324f', 'stroke-width':(4 / s).toFixed(2), 'stroke-linecap':'round',
    transform:'translate(' + (118 - 50 * s) + ',' + (128 - 50 * s) + ') scale(' + s + ')' }));
  return svg;
}

/* === Kissen: Love Paw — Pfotenabdruck als "O" in L-O-VE (1:1) === */
function buildLovePaw() {
  const svg = _svgRoot(1000, 1000);
  const cx = 487, cy = 830, white = '#ffffff', pink = '#e7b8bf';
  svg.appendChild(_el('ellipse', { cx:cx, cy:cy + 16, rx:33, ry:27, fill:pink }));
  [[-29, -15, 12, 16], [-11, -30, 11, 15], [11, -30, 11, 15], [29, -15, 12, 16]].forEach(function (t) {
    svg.appendChild(_el('ellipse', { cx:cx + t[0], cy:cy + t[1], rx:t[2], ry:t[3], fill:white }));
  });
  return svg;
}

/* === Kissen: Neutral Foliage — weiße Blatt-Sprigs auf Beige (Underlay, 1:1) === */
function buildFoliageUnderlay() {
  const S = 1000, svg = _svgRoot(S, S);
  svg.appendChild(_el('rect', { x:0, y:0, width:S, height:S, fill:'#d7cdbe' }));
  function leaf(cx, cy, rot, sc) {
    const g = _el('g', { transform:'translate(' + cx + ',' + cy + ') rotate(' + rot + ') scale(' + sc + ')', opacity:0.5 });
    g.appendChild(_el('path', { d:'M0,0 C18,-26 18,-62 0,-92 C-18,-62 -18,-26 0,0 Z', fill:'#ffffff' }));
    return g;
  }
  const sprigs = [[70,110,15],[180,50,-35],[55,420,8],[95,820,-22],[210,930,42],[500,45,0],[815,80,-18],[940,310,28],[905,710,-12],[815,935,32],[520,955,4],[300,940,-28],[660,930,18]];
  sprigs.forEach(function (sp) { for (let i = 0; i < 4; i++) svg.appendChild(leaf(sp[0], sp[1], sp[2] + i * 42 - 63, 0.62)); });
  return svg;
}

const OVERLAY_BUILDERS = {
  'quilt-border': buildQuiltBorderSVG,
  'best-mom': buildBestMom,
  'do-not-disturb': buildDoNotDisturb,
  'painted-stripes': buildPaintedStripes,
  'cool-moms': buildCoolMoms,
  'heart-border': buildHeartBorder,
  'painted-gingham': buildPaintedGingham,
  'whimsy-heart-border': buildWhimsyHeartBorder,
  'heart-film-doodle': buildHeartFilmDoodle,
  'love-paw': buildLovePaw
};
function buildColorblocksUnderlay(opts) {
  const c = (opts && opts.colors) || ['#efe9dd', '#dccfbb', '#cdc4b5', '#e7e0d2'];
  const svg = _svgRoot(W7, H10);
  const hw = W7 / 2, hh = H10 / 2;
  svg.appendChild(_el('rect', { x:0,  y:0,  width:hw, height:hh, fill:c[0] }));   // oben links
  svg.appendChild(_el('rect', { x:hw, y:0,  width:hw, height:hh, fill:c[1] }));   // oben rechts
  svg.appendChild(_el('rect', { x:0,  y:hh, width:hw, height:hh, fill:c[2] }));   // unten links
  svg.appendChild(_el('rect', { x:hw, y:hh, width:hw, height:hh, fill:c[3] }));   // unten rechts
  return svg;
}

function buildMoonStarsUnderlay() {
  const svg = _svgRoot(1000, 700);   // Querformat-ViewBox
  const stars = [[10.1,71.3,16],[90.7,63.1,14],[89.9,75.1,14],[65.4,58.0,26],[61.1,3.9,16],[9.7,15.3,16],[27.8,63.0,22],[41.2,87.0,30],[46.6,69.7,36],[10.0,78.0,36],[4.5,47.4,16],[50.7,5.3,18],[73.0,18.6,30],[81.3,92.0,30],[27.6,3.7,22],[32.3,23.0,18],[54.5,26.9,22],[69.0,66.7,30],[92.8,37.4,22],[42.9,38.7,18],[66.4,65.1,18],[91.6,33.4,26],[23.9,87.4,22],[22.9,22.0,18],[52.3,53.4,14],[74.3,11.4,22],[85.6,26.9,16],[47.6,71.0,22],[96.2,33.4,26],[40.6,93.6,36],[52.0,48.1,30],[34.3,13.0,14],[29.9,91.0,14],[70.9,43.1,22],[33.1,97.0,14],[67.1,22.0,26],[48.0,29.9,14],[80.2,41.0,18],[81.2,22.7,14],[65.9,19.0,30]];
  stars.forEach(function (s) { svg.appendChild(_star(s[0] / 100 * 1000, s[1] / 100 * 700, s[2] / 2, '#e7ecf5')); });
  return svg;
}

const UNDERLAY_BUILDERS = {
  'plaid': buildPlaidUnderlay,
  'pinstripe': buildPinstripeUnderlay,
  'colorblocks': buildColorblocksUnderlay,
  'moonstars': buildMoonStarsUnderlay,
  'foliage': buildFoliageUnderlay
};

  /* ===================================================================
   * Modul-State
   * =================================================================== */
  let root, stage, sectionId, layoutId, assets;
  let activeLayout, currentGrid;
  const state = { texts: [], bgColor: '#ffffff', paper_size: '', product_type: '', variant_id: '', frame_color: 'brown', design_color: '#ffffff' };
  const photoSrcs = {};   // slot-index -> objectURL (Vorschau, Original)
  const slotData = {};    // slot-index -> { user_image_url, crop:{x,y,w,h}|null }
  const cropSource = {};  // slot-index -> objectURL des Originals (für Crop-Modal)

  function getLayout(id) {
    for (let i = 0; i < LAYOUTS.length; i++) if (LAYOUTS[i].id === id) return LAYOUTS[i];
    return null;
  }
  // PROJ-13: kuratierte Poster-Motive (Block 2: 6 Hochformat-Motive)
  var POSTER_MOTIFS = ['vier-grid', 'foto-grid-8', 'drei-reihen', 'filmstrip', 'klassik', 'family-hoch', 'love-collage', 'mega-papa', 'schraeg-stapel'];
  function isDeckeLayout(l) { return POSTER_MOTIFS.indexOf(l.id) !== -1; }
  var LAYOUT_PRODUCTS = {};   // layout_id → { handle, variants:{ "Typ|Größe":{id,price} } } (aus Liquid-JSON)
  function totalSlots(layout) {
    let n = layout.photos.length;
    (layout.bars || []).forEach(function (bar) { n += (bar.cols || 1); });
    return n;
  }
  function deepCloneLayout(l) {
    return {
      id: l.id, name: l.name, sub: l.sub, aspect: l.aspect, blanketPad: l.blanketPad,
      photoStyle: l.photoStyle, blanketColor: l.blanketColor, allPhotos: l.allPhotos,
      panel: l.panel ? Object.assign({}, l.panel) : null,
      grid: Object.assign({}, l.grid),
      overlay: l.overlay ? Object.assign({}, l.overlay, l.overlay.colors ? { colors: l.overlay.colors.slice() } : {}) : null,
      underlay: l.underlay ? Object.assign({}, l.underlay, l.underlay.colors ? { colors: l.underlay.colors.slice() } : {}) : null,
      frame: l.frame ? Object.assign({}, l.frame, l.frame.colors ? { colors: l.frame.colors.slice() } : {}) : null,
      photos: (l.photos || []).map(function (p) { return Object.assign({}, p); }),
      bars: (l.bars || []).map(function (b) { return Object.assign({}, b); }),
      texts: (l.texts || []).map(function (t) { return Object.assign({}, t); })
    };
  }

  /* ===================================================================
   * Crop-Positionierung (geteilt mit dem Server-Print-Mode)
   * crop = normierte {x,y,w,h} (0..1) der natürlichen Bildfläche.
   * Bild wird absolut so platziert, dass die Crop-Region den Slot füllt
   * (Crop-Seitenverhältnis == Slot-Seitenverhältnis → keine Verzerrung).
   * =================================================================== */
  function applyCrop(img, crop) {
    if (!crop) { img.removeAttribute('style'); return; }
    img.style.inset = 'auto';
    img.style.position = 'absolute';
    img.style.left = (-(crop.x / crop.w) * 100) + '%';
    img.style.top = (-(crop.y / crop.h) * 100) + '%';
    img.style.width = (100 / crop.w) + '%';
    img.style.height = (100 / crop.h) + '%';
    img.style.maxWidth = 'none';
    img.style.objectFit = 'cover';
  }

  /* ===================================================================
   * Layout laden + Stage rendern (Port aus collage-engine.html)
   * =================================================================== */
  function loadLayout(id) {
    activeLayout = deepCloneLayout(getLayout(id) || LAYOUTS[0]);
    state.texts = activeLayout.texts;
    state.bgColor = activeLayout.blanketColor || '#ffffff';
    state.design_color = state.bgColor;
    var _src = getLayout(id) || LAYOUTS[0]; var _na = String(_src.aspect).split('/'); activeLayout._landscape = (parseFloat(_na[0]) / parseFloat(_na[1])) >= 1;
    Object.keys(photoSrcs).forEach(function (k) { delete photoSrcs[k]; });
    Object.keys(slotData).forEach(function (k) { delete slotData[k]; });
    Object.keys(cropSource).forEach(function (k) { delete cropSource[k]; });
    if (stage) {
      stage.style.setProperty('--collage-aspect', activeLayout.aspect);
      if (assets && assets.fleece) stage.style.setProperty('--fleece-tex', "url('" + assets.fleece + "')");
      // Orientierung: Querformat über Breite begrenzen, Hochformat über Höhe (sonst zu hoch)
      var arP = String(activeLayout.aspect).split('/');
      var arN = (parseFloat(arP[0]) || 1) / (parseFloat(arP[1]) || 1);
      stage.classList.toggle('is-landscape', arN >= 1);
      stage.classList.toggle('is-portrait', arN < 1);
    }
    renderStage();
    buildPhotoSlotList();
    buildTextFields();
    syncColorPicker();
    buildPatternColorPickers();
    syncStageToSize();
  }

  function renderStage() {
    const layout = activeLayout;
    if (!stage) return;
    stage.style.setProperty('--collage-aspect', layout.aspect);

    const grid = document.createElement('div');
    grid.className = 'collage-grid ' + (layout.panel ? 'has-panel' : 'no-panel');
    grid.style.padding = layout.blanketPad + 'cqw';
    const _fc = (layout.frame && layout.frame.colors) ? layout.frame.colors : null;   // Doppelrahmen: [Außen, Innen]
    if (_fc) { state.bgColor = _fc[0]; state.design_color = _fc[0]; }
    grid.style.setProperty('--blanket-color', state.bgColor);
    currentGrid = grid;

    if (layout.underlay && UNDERLAY_BUILDERS[layout.underlay.type]) {
      const un = document.createElement('div');
      un.className = 'collage-underlay';
      un.appendChild(UNDERLAY_BUILDERS[layout.underlay.type](layout.underlay));
      grid.appendChild(un);
    }

    let container;
    if (layout.panel) {
      const p = document.createElement('div');
      p.className = 'panel';
      p.style.setProperty('--panel-color', _fc ? _fc[1] : layout.panel.color);
      p.style.padding = layout.panel.pad + 'cqw';
      p.style.gridTemplateColumns = layout.grid.cols;
      p.style.gridTemplateRows = layout.grid.rows;
      p.style.gap = layout.grid.gap + 'cqw';
      grid.appendChild(p);
      container = p;
    } else {
      grid.style.gridTemplateColumns = layout.grid.cols;
      grid.style.gridTemplateRows = layout.grid.rows;
      grid.style.gap = layout.grid.gap + 'cqw';
      container = grid;
    }

    layout.photos.forEach(function (ph, i) {
      const s = document.createElement('div');
      s.className = 'photo-slot' + (layout.photoStyle === 'mat' ? ' mat' : '');
      s.setAttribute('data-slot-index', i);
      if (photoSrcs[i]) {
        s.classList.add('has-photo');
        s.innerHTML = '<img class="photo" src="' + photoSrcs[i] + '" alt="">';
      } else {
        s.innerHTML = '<div class="cta">' + CAM + '<span>Foto</span></div>';
      }
      s.title = 'Tippen: Foto laden / Ausschnitt wählen';
      if (ph.x != null) {
        s.style.position = 'absolute';
        s.style.left = ph.x + '%'; s.style.top = ph.y + '%';
        s.style.width = ph.w + '%'; s.style.height = ph.h + '%';
        s.style.zIndex = 2 + i;
        if (ph.rot) s.style.transform = 'rotate(' + ph.rot + 'deg)';
        grid.appendChild(s);
        makeDraggable(s, ph, i);
      } else {
        s.style.gridColumn = ph.c; s.style.gridRow = ph.r;
        s.style.cursor = 'pointer';
        (function (ci, se) { se.addEventListener('click', function () { onSlotTap(ci, se); }); })(i, s);
        container.appendChild(s);
      }
      if (photoSrcs[i] && slotData[i] && slotData[i].crop) {
        const im = s.querySelector('img.photo'); if (im) applyCrop(im, slotData[i].crop);
      }
    });

    let barIdx = layout.photos.length;
    (layout.bars || []).forEach(function (bar, bi) {
      const b = document.createElement('div');
      b.className = 'photo-bar';
      b.style.left = bar.x + '%'; b.style.top = bar.y + '%';
      b.style.width = bar.w + '%'; b.style.height = bar.h + '%';
      b.style.zIndex = 3 + bi;
      if (bar.rot) b.style.transform = 'rotate(' + bar.rot + 'deg)';
      for (let k = 0; k < (bar.cols || 1); k++) {
        const idx = barIdx++;
        const cell = document.createElement('div');
        cell.className = 'bar-cell photo-slot';
        cell.setAttribute('data-slot-index', idx);
        if (photoSrcs[idx]) {
          cell.classList.add('has-photo');
          cell.innerHTML = '<img class="photo" src="' + photoSrcs[idx] + '" alt="">';
        } else {
          cell.innerHTML = '<div class="cta">' + CAM + '</div>';
        }
        cell.style.cursor = 'pointer';
        (function (ci, ce) { ce.addEventListener('click', function () { onSlotTap(ci, ce); }); })(idx, cell);
        if (photoSrcs[idx] && slotData[idx] && slotData[idx].crop) {
          const im = cell.querySelector('img.photo'); if (im) applyCrop(im, slotData[idx].crop);
        }
        b.appendChild(cell);
      }
      grid.appendChild(b);
    });

    if (layout.overlay && OVERLAY_BUILDERS[layout.overlay.type]) {
      const ov = document.createElement('div');
      ov.className = 'collage-overlay';
      ov.appendChild(OVERLAY_BUILDERS[layout.overlay.type](layout.overlay));
      grid.appendChild(ov);
    }

    state.texts.forEach(function (t, ti) {
      const el = document.createElement('div');
      el.className = 'text-slot';
      el.setAttribute('data-text-index', ti);
      el.style.fontFamily = "'" + (t.font || 'Playfair Display') + "', serif";
      el.style.fontWeight = t.weight || 700;
      el.style.color = t.color || '#28292d';
      el.style.fontSize = (t.size || 5) + 'cqw';
      if (t.upper) el.style.textTransform = 'uppercase';
      if (t.italic) el.style.fontStyle = 'italic';
      if (t.spacing) el.style.letterSpacing = t.spacing;
      el.textContent = t.content;
      if (t.free) {
        el.style.position = 'absolute';
        el.style.left = (t.x != null ? t.x : 50) + '%';
        el.style.top = (t.y != null ? t.y : 50) + '%';
        el.style.transform = 'translate(-50%, -50%)';
        el.style.zIndex = 7; el.style.whiteSpace = 'nowrap'; el.style.justifyContent = 'center';
        grid.appendChild(el);
      } else {
        // Text in einen Grid-Zellen-Wrapper legen: der Wrapper nimmt den definierten
        // Grid-Platz ein (Größe von Fotos/Spuren bestimmt), der Text selbst ist absolut
        // positioniert und beeinflusst die Spur-Größe NICHT mehr. Verhindert, dass langer
        // Text die Spalte/Zeile dehnt und die Fotos verzerrt.
        var tcell = document.createElement('div');
        tcell.style.gridColumn = t.c; tcell.style.gridRow = t.r;
        tcell.style.position = 'relative';
        tcell.style.minWidth = '0'; tcell.style.minHeight = '0';
        el.style.position = 'absolute';
        el.style.top = '50%';
        el.style.whiteSpace = 'nowrap';
        var tj = t.justify || 'center';
        if (tj === 'flex-start') { el.style.left = '0'; el.style.transform = 'translateY(-50%)'; }
        else if (tj === 'flex-end') { el.style.right = '0'; el.style.transform = 'translateY(-50%)'; }
        else { el.style.left = '50%'; el.style.transform = 'translate(-50%, -50%)'; }
        if (t.pad) el.style.padding = t.pad;
        tcell.appendChild(el);
        container.appendChild(tcell);
      }
    });

    stage.innerHTML = '';
    stage.appendChild(grid);
  }

  /* Tippen öffnet Foto-Wahl/Crop. Verschieben wurde ENTFERNT — die Fotos bleiben
     in der vordefinierten Layout-Anordnung (ph.x/ph.y werden nicht mehr mutiert). */
  function makeDraggable(el, ph, idx) {
    el.style.cursor = 'pointer';
    el.addEventListener('click', function () {
      if (idx != null) onSlotTap(idx, el);
    });
  }

  function onSlotTap(i, el) {
    if (photoSrcs[i]) openCropModal(i, el);
    else pickPhotoFor(i, el);
  }

  /* ===================================================================
   * Foto-Upload (objectURL-Sofortvorschau + S3 im Hintergrund)
   * =================================================================== */
  function validateFile(f) {
    if (!ACCEPTED_TYPES.includes(f.type) && !/\.(jpg|jpeg|png|heic|heif)$/i.test(f.name)) {
      alert('Format nicht unterstützt — bitte JPG, PNG oder HEIC'); return false;
    }
    if (f.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert('Datei zu groß — max ' + MAX_FILE_SIZE_MB + ' MB'); return false;
    }
    return true;
  }

  let _uploadInput = null;
  function pickPhotoFor(i, slotEl) {
    if (!_uploadInput) {
      _uploadInput = document.createElement('input');
      _uploadInput.type = 'file'; _uploadInput.accept = 'image/jpeg,image/png,image/heic,image/heif';
      _uploadInput.style.display = 'none'; document.body.appendChild(_uploadInput);
    }
    const inp = _uploadInput; inp.value = ''; inp.multiple = false;
    inp.onchange = function () { const f = inp.files && inp.files[0]; if (f) setSlotImage(i, f, slotEl, function () { openCropModal(i, slotEl); }); };
    inp.click();
  }

  // Cropper.js crasht/haengt bei grossen Fotos (12-48 MP) -> vor dem Croppen
  // auf max 2400px Long-Side downscalen (1:1 Pattern aus photo.js). Liefert
  // eine kleine JPEG-DataURL; bei kleinen Bildern die Original-objectURL.
  function downscaleForCrop(file, maxSide) {
    return new Promise(function (resolve) {
      const url = URL.createObjectURL(file);
      const im = new Image();
      im.onload = function () {
        const w = im.naturalWidth, h = im.naturalHeight;
        if (!w || !h || (w <= maxSide && h <= maxSide)) { resolve(url); return; }
        const scale = maxSide / Math.max(w, h);
        const c = document.createElement('canvas');
        c.width = Math.round(w * scale); c.height = Math.round(h * scale);
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', 0.9));
      };
      im.onerror = function () { resolve(url); };
      im.src = url;
    });
  }

  function setSlotImage(i, file, slotEl, onReady) {
    if (!validateFile(file)) return;
    const url = URL.createObjectURL(file);
    photoSrcs[i] = url;
    cropSource[i] = url;
    slotData[i] = slotData[i] || {};
    slotData[i].crop = null;   // neuer Upload → Crop zurücksetzen
    if (!slotEl) slotEl = stage.querySelector('[data-slot-index="' + i + '"]');
    if (slotEl) {
      let img = slotEl.querySelector('img.photo');
      if (!img) {
        slotEl.classList.add('has-photo');
        const cta = slotEl.querySelector('.cta'); if (cta) cta.remove();
        img = document.createElement('img'); img.className = 'photo';
        slotEl.insertBefore(img, slotEl.firstChild);
      }
      img.removeAttribute('style'); img.src = url;
    }
    updatePhotoCounter();
    refreshSlotListItem(i);
    uploadToS3(file).then(function (publicUrl) {
      slotData[i].user_image_url = publicUrl;
    }).catch(function (err) { console.error('[collage-poster] S3 upload failed slot ' + i, err); });
    // Downscaled Version für den Cropper bereitstellen, DANN erst Crop öffnen.
    downscaleForCrop(file, 2400).then(function (durl) {
      cropSource[i] = durl;
      if (typeof onReady === 'function') onReady();
    });
  }

  function distributeFiles(files) {
    const list = Array.prototype.slice.call(files);
    const total = totalSlots(activeLayout);
    let fi = 0;
    for (let i = 0; i < total && fi < list.length; i++) {
      if (photoSrcs[i]) continue;
      setSlotImage(i, list[fi], null);
      fi++;
    }
  }

  async function uploadToS3(file) {
    const presignedResp = await fetch(BACKEND_API_URL + '/api/v1/upload/presigned-url/', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name || 'decke-photo.jpg', content_type: file.type || 'image/jpeg' }),
    });
    if (!presignedResp.ok) throw new Error('Presigned URL failed: HTTP ' + presignedResp.status);
    const presigned = await presignedResp.json();
    const uploadUrl = presigned.uploadUrl || presigned.upload_url;
    const publicUrl = presigned.publicUrl || presigned.public_url;
    const fields = presigned.fields || {};
    if (!uploadUrl || !publicUrl) throw new Error('Invalid presigned response');
    const formData = new FormData();
    Object.keys(fields).forEach(function (k) { formData.append(k, fields[k]); });
    formData.append('file', file);
    const uploadResp = await fetch(uploadUrl, { method: 'POST', body: formData });
    if (!uploadResp.ok && uploadResp.status !== 204) throw new Error('S3 upload failed: HTTP ' + uploadResp.status);
    return publicUrl;
  }

  /* ===================================================================
   * Crop-Modal (Cropper.js, on-demand vom CDN)
   * =================================================================== */
  let _cropper = null, _cropBackdrop = null, _cropSlotIndex = null, _cropInitialRatio = null;
  function ensureCropper() {
    return new Promise(function (resolve, reject) {
      if (window.Cropper) { resolve(); return; }
      if (!document.querySelector('link[data-cropper]')) {
        const lk = document.createElement('link');
        lk.rel = 'stylesheet'; lk.href = CROPPER_CSS_URL; lk.setAttribute('data-cropper', '1');
        document.head.appendChild(lk);
      }
      const sc = document.createElement('script');
      sc.src = CROPPER_JS_URL;
      sc.onload = function () { resolve(); };
      sc.onerror = function () { reject(new Error('Cropper konnte nicht geladen werden')); };
      document.head.appendChild(sc);
    });
  }
  function buildCropBackdrop() {
    const bd = document.createElement('div');
    bd.className = 'collage-cropper-modal-backdrop';
    bd.innerHTML =
      '<div class="collage-cropper-modal">' +
        '<div class="collage-cropper-modal-header"><h3>Foto zuschneiden</h3></div>' +
        '<div class="collage-cropper-wrapper"><img alt=""></div>' +
        '<p class="collage-cropper-help">Verschiebe den Rahmen oder seine Ecken, um dein Bild zuzuschneiden. Mit Mausrad oder Slider kannst du zoomen.</p>' +
        '<div class="collage-cropper-zoom-bar">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-out" aria-label="Verkleinern">−</button>' +
          '<input type="range" class="collage-zoom-slider" min="100" max="200" value="100" aria-label="Zoom">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-in" aria-label="Vergrößern">+</button>' +
        '</div>' +
        '<div class="collage-cropper-modal-footer">' +
          '<button type="button" class="collage-crop-cancel">Abbrechen</button>' +
          '<button type="button" class="primary collage-crop-apply">Zuschneiden &amp; übernehmen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bd);
    bd.addEventListener('click', function (e) { if (e.target === bd) closeCropModal(); });
    bd.querySelector('.collage-crop-cancel').addEventListener('click', closeCropModal);
    bd.querySelector('.collage-crop-apply').addEventListener('click', applyCropFromModal);
    const zs = bd.querySelector('.collage-zoom-slider');
    if (zs) zs.addEventListener('input', function () {
      if (!_cropper || !_cropInitialRatio) return;
      _cropper.zoomTo(_cropInitialRatio * (parseInt(this.value, 10) / 100));
    });
    bd.querySelector('.collage-zoom-in').addEventListener('click', function () { if (_cropper) _cropper.zoom(0.1); });
    bd.querySelector('.collage-zoom-out').addEventListener('click', function () { if (_cropper) _cropper.zoom(-0.1); });
    return bd;
  }
  function openCropModal(i, slotEl) {
    _cropSlotIndex = i;
    if (!cropSource[i]) { pickPhotoFor(i, slotEl); return; }
    ensureCropper().then(function () {
      if (!_cropBackdrop) _cropBackdrop = buildCropBackdrop();
      _cropBackdrop.classList.add('visible');
      document.body.style.overflow = 'hidden';
      initCropperImage(i, slotEl);
    }).catch(function (e) { console.error(e); alert('Crop-Editor konnte nicht geladen werden.'); });
  }
  function initCropperImage(i, slotEl) {
    const img = _cropBackdrop.querySelector('.collage-cropper-wrapper img');
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    let aspect = NaN;
    const el = slotEl || stage.querySelector('[data-slot-index="' + i + '"]');
    if (el) { const r = el.getBoundingClientRect(); if (r.width && r.height) aspect = r.width / r.height; }
    // img.onload kann doppelt feuern (synchron via if(img.complete) UND async via
    // Load-Event) -> zwei Cropper auf demselben Bild, der zweite kaputt (canvasData
    // leer -> Zoom wirft "reading width"). Single-Init-Sperre verhindert das.
    let _built = false;
    img.onload = function () {
      if (_built) return; _built = true;
      // rAF wie Foto-Poster (photo.js:698): Modal ist gerade erst sichtbar geworden —
      // ohne diesen Frame-Aufschub misst Cropper.js den Container als 0x0 und
      // positioniert Bild/Crop-Box falsch (dort dokumentierter Bug-Fix).
      requestAnimationFrame(function () {
      _cropper = new Cropper(img, {
        aspectRatio: aspect || NaN,
        viewMode: 1, autoCropArea: 1,
        movable: true, zoomable: true, rotatable: false, scalable: false,
        cropBoxResizable: true, responsive: false, background: false, modal: true,
        dragMode: 'none', toggleDragModeOnDblclick: false, // kein Neu-Aufziehen ausserhalb der Box (Clarity 10.08.)
        minCropBoxWidth: 60, minCropBoxHeight: 60,
        wheelZoomRatio: 0.08,
        ready: function () {
          const cd = _cropper.getCanvasData();
          _cropInitialRatio = cd.naturalWidth ? (cd.width / cd.naturalWidth) : null;
          const zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
          if (zs) zs.value = 100;
          const c = slotData[i] && slotData[i].crop;
          if (c) {
            const d = _cropper.getImageData();
            _cropper.setData({ x: c.x * d.naturalWidth, y: c.y * d.naturalHeight, width: c.w * d.naturalWidth, height: c.h * d.naturalHeight });
          }
        },
        zoom: function (ev) {
          if (!_cropInitialRatio) return;
          const zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
          if (zs) { const pct = Math.round((ev.detail.ratio / _cropInitialRatio) * 100); zs.value = Math.max(100, Math.min(200, pct)); }
        }
      });
      });
    };
    img.src = cropSource[i];
    if (img.complete && img.naturalWidth) img.onload();
  }
  function applyCropFromModal() {
    if (!_cropper || _cropSlotIndex == null) { closeCropModal(); return; }
    const data = _cropper.getData();
    const id = _cropper.getImageData();
    const NW = id.naturalWidth || 1, NH = id.naturalHeight || 1;
    const crop = {
      x: Math.max(0, Math.min(1, data.x / NW)),
      y: Math.max(0, Math.min(1, data.y / NH)),
      w: Math.max(0.01, Math.min(1, data.width / NW)),
      h: Math.max(0.01, Math.min(1, data.height / NH))
    };
    slotData[_cropSlotIndex] = slotData[_cropSlotIndex] || {};
    slotData[_cropSlotIndex].crop = crop;
    const el = stage.querySelector('[data-slot-index="' + _cropSlotIndex + '"]');
    if (el) { const im = el.querySelector('img.photo'); if (im) applyCrop(im, crop); }
    closeCropModal();
  }
  function closeCropModal() {
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    if (_cropBackdrop) _cropBackdrop.classList.remove('visible');
    document.body.style.overflow = '';
    _cropSlotIndex = null;
  }

  /* ===================================================================
   * Tab-Inhalte (aus aktivem Layout generiert)
   * =================================================================== */
  /* Picker-Produktwechsel (PROJ-13, Kissen/Letter-Pattern): variant_ids/Preise im
     server-gerenderten Produkt-Tab umschreiben + URL auf die Motiv-Page setzen. */
  function switchProduct(id) {
    var prod = LAYOUT_PRODUCTS[id];
    if (!prod || !prod.variants) return;   // Produkt existiert (noch) nicht → nur Layout
    root.querySelectorAll('.tab__switcher a[data-id]').forEach(function (typeLink) {
      var type = typeLink.getAttribute('data-type');
      var fmt = root.querySelector('.el__format[data-id="' + typeLink.getAttribute('data-id') + '"]');
      if (!fmt) return;
      fmt.querySelectorAll('.size__picker a[data-size]').forEach(function (a) {
        var v = prod.variants[type + '|' + a.getAttribute('data-size')];
        if (v) {
          a.setAttribute('data-variant-id', String(v.id));
          if (v.price) a.setAttribute('data-price', String(Math.round(parseFloat(String(v.price).replace(',', '.')) * 100)));
        }
      });
    });
    var current = root.querySelector('.el__format .size__picker a.current[data-variant-id]');
    if (current) {
      state.variant_id = current.getAttribute('data-variant-id');
      var vi = document.getElementById('collage-poster-variant-id-' + sectionId);
      if (vi) vi.value = state.variant_id;
      var priceEl = root.querySelector('.bottom__controls .variant-price');
      var cents = current.getAttribute('data-price');
      if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    }
    if (prod.handle && window.history && history.replaceState) {
      try { history.replaceState(null, '', '/pages/' + prod.handle + '-gestalten'); } catch (e) { /* still */ }
    }
  }

  function buildLayoutPicker() {
    const host = document.getElementById('collage-poster-layout-picker-' + sectionId);
    if (!host) return;
    host.innerHTML = '';
    const ul = document.createElement('ul');
    ul.className = 'collage-template-picker';
    LAYOUTS.filter(isDeckeLayout).forEach(function (l) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'collage-template' + (l.id === layoutId ? ' current' : '');
      a.setAttribute('data-layout', l.id);
      a.setAttribute('aria-label', l.name);
      const thumb = document.createElement('span');
      thumb.className = 'collage-template-thumb';
      renderLayoutThumb(l, thumb);
      const name = document.createElement('span');
      name.className = 'collage-template-name';
      name.textContent = l.name;
      a.appendChild(thumb); a.appendChild(name);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        ul.querySelectorAll('.collage-template').forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        layoutId = l.id;
        loadLayout(l.id);
        switchProduct(l.id);
        if (a.scrollIntoView) a.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      li.appendChild(a); ul.appendChild(li);
    });
    host.appendChild(ul);
  }

  /* Mini-Vorschau eines Layouts für die Thumbnail-Kachel (statisch, graue Slots) */
  function renderLayoutThumb(layout, host) {
    const stage = document.createElement('div');
    stage.className = 'collage-stage is-thumb';
    stage.style.setProperty('--collage-aspect', layout.aspect);
    stage.style.setProperty('--blanket-color', layout.blanketColor || '#CBCBCB');
    // Einheitliche Hochformat-Icons: Quer-Layouts sitzen mittig in der Hochformat-Box
    // (Rand = Deckenfarbe), nur das Icon — der Editor zeigt das Layout in echtem Querformat.
    host.style.backgroundColor = layout.blanketColor || '#CBCBCB';
    var arParts = String(layout.aspect).split('/');
    var arNum = (parseFloat(arParts[0]) || 1) / (parseFloat(arParts[1]) || 1);
    if (arNum > 1.02) { stage.style.width = '100%'; stage.style.height = 'auto'; }
    else { stage.style.height = '100%'; stage.style.width = 'auto'; }

    const grid = document.createElement('div');
    grid.className = 'collage-grid ' + (layout.panel ? 'has-panel' : 'no-panel');
    grid.style.padding = layout.blanketPad + 'cqw';
    grid.style.setProperty('--blanket-color', layout.blanketColor || '#CBCBCB');

    if (layout.underlay && UNDERLAY_BUILDERS[layout.underlay.type]) {
      const un = document.createElement('div'); un.className = 'collage-underlay';
      un.appendChild(UNDERLAY_BUILDERS[layout.underlay.type](layout.underlay)); grid.appendChild(un);
    }
    let container;
    if (layout.panel) {
      const p = document.createElement('div'); p.className = 'panel';
      p.style.setProperty('--panel-color', layout.panel.color);
      p.style.padding = layout.panel.pad + 'cqw';
      p.style.gridTemplateColumns = layout.grid.cols;
      p.style.gridTemplateRows = layout.grid.rows;
      p.style.gap = layout.grid.gap + 'cqw';
      grid.appendChild(p); container = p;
    } else {
      grid.style.gridTemplateColumns = layout.grid.cols;
      grid.style.gridTemplateRows = layout.grid.rows;
      grid.style.gap = layout.grid.gap + 'cqw';
      container = grid;
    }
    (layout.photos || []).forEach(function (ph, i) {
      const s = document.createElement('div');
      s.className = 'photo-slot' + (layout.photoStyle === 'mat' ? ' mat' : '');
      if (ph.x != null) {
        s.style.position = 'absolute';
        s.style.left = ph.x + '%'; s.style.top = ph.y + '%';
        s.style.width = ph.w + '%'; s.style.height = ph.h + '%';
        s.style.zIndex = 2 + i;
        if (ph.rot) s.style.transform = 'rotate(' + ph.rot + 'deg)';
        grid.appendChild(s);
      } else {
        s.style.gridColumn = ph.c; s.style.gridRow = ph.r;
        container.appendChild(s);
      }
    });
    (layout.bars || []).forEach(function (bar, bi) {
      const b = document.createElement('div'); b.className = 'photo-bar';
      b.style.left = bar.x + '%'; b.style.top = bar.y + '%';
      b.style.width = bar.w + '%'; b.style.height = bar.h + '%';
      b.style.zIndex = 3 + bi;
      if (bar.rot) b.style.transform = 'rotate(' + bar.rot + 'deg)';
      for (let k = 0; k < (bar.cols || 1); k++) { const cell = document.createElement('div'); cell.className = 'bar-cell'; b.appendChild(cell); }
      grid.appendChild(b);
    });
    if (layout.overlay && OVERLAY_BUILDERS[layout.overlay.type]) {
      const ov = document.createElement('div'); ov.className = 'collage-overlay';
      ov.appendChild(OVERLAY_BUILDERS[layout.overlay.type](layout.overlay)); grid.appendChild(ov);
    }
    (layout.texts || []).forEach(function (t) {
      const el = document.createElement('div'); el.className = 'text-slot';
      el.style.fontFamily = "'" + (t.font || 'Playfair Display') + "', serif";
      el.style.fontWeight = t.weight || 700;
      el.style.color = t.color || '#28292d';
      el.style.fontSize = (t.size || 5) + 'cqw';
      if (t.upper) el.style.textTransform = 'uppercase';
      if (t.italic) el.style.fontStyle = 'italic';
      if (t.spacing) el.style.letterSpacing = t.spacing;
      el.textContent = t.content;
      if (t.free) {
        el.style.position = 'absolute';
        el.style.left = (t.x != null ? t.x : 50) + '%';
        el.style.top = (t.y != null ? t.y : 50) + '%';
        el.style.transform = 'translate(-50%, -50%)';
        el.style.zIndex = 7; el.style.whiteSpace = 'nowrap'; el.style.justifyContent = 'center';
        grid.appendChild(el);
      } else {
        // Text in einen Grid-Zellen-Wrapper legen: der Wrapper nimmt den definierten
        // Grid-Platz ein (Größe von Fotos/Spuren bestimmt), der Text selbst ist absolut
        // positioniert und beeinflusst die Spur-Größe NICHT mehr. Verhindert, dass langer
        // Text die Spalte/Zeile dehnt und die Fotos verzerrt.
        var tcell = document.createElement('div');
        tcell.style.gridColumn = t.c; tcell.style.gridRow = t.r;
        tcell.style.position = 'relative';
        tcell.style.minWidth = '0'; tcell.style.minHeight = '0';
        el.style.position = 'absolute';
        el.style.top = '50%';
        el.style.whiteSpace = 'nowrap';
        var tj = t.justify || 'center';
        if (tj === 'flex-start') { el.style.left = '0'; el.style.transform = 'translateY(-50%)'; }
        else if (tj === 'flex-end') { el.style.right = '0'; el.style.transform = 'translateY(-50%)'; }
        else { el.style.left = '50%'; el.style.transform = 'translate(-50%, -50%)'; }
        if (t.pad) el.style.padding = t.pad;
        tcell.appendChild(el);
        container.appendChild(tcell);
      }
    });
    stage.appendChild(grid);
    host.appendChild(stage);
  }

  function buildPhotoSlotList() {
    const host = document.getElementById('collage-poster-photo-controls-' + sectionId);
    if (!host) return;
    const n = totalSlots(activeLayout);
    const ul = document.createElement('ul');
    ul.className = 'collage-photo-slot-list';
    for (let i = 0; i < n; i++) {
      const li = document.createElement('li');
      li.className = 'collage-photo-slot-item';
      li.setAttribute('data-slot-index', i);

      const thumb = document.createElement('span');
      thumb.className = 'collage-photo-slot-thumb';
      const timg = document.createElement('img'); timg.alt = '';
      timg.src = photoSrcs[i] || (assets && assets.placeholder) || '';
      thumb.appendChild(timg);

      const label = document.createElement('span');
      label.className = 'collage-photo-slot-label';
      label.textContent = 'Foto ' + (i + 1);

      const btn = document.createElement('label');
      btn.className = 'photo-upload-button collage-photo-slot-upload';
      const span = document.createElement('span');
      span.textContent = photoSrcs[i] ? 'Ändern' : 'Foto hochladen';
      const inp = document.createElement('input');
      inp.type = 'file'; inp.accept = 'image/jpeg,image/png,image/heic,image/heif';
      (function (idx) {
        inp.addEventListener('change', function (e) {
          const f = e.target.files && e.target.files[0];
          if (f) setSlotImage(idx, f, null, function () { openCropModal(idx, null); });
          e.target.value = '';
        });
        thumb.addEventListener('click', function () { if (photoSrcs[idx]) openCropModal(idx, null); });
      })(i);
      btn.appendChild(span); btn.appendChild(inp);

      li.appendChild(thumb); li.appendChild(label); li.appendChild(btn);
      ul.appendChild(li);
    }
    host.innerHTML = '';
    host.appendChild(ul);
  }

  function updatePhotoCounter() { /* Slot-Liste zeigt Status via Thumbs — no-op */ }

  function refreshSlotListItem(i) {
    const li = document.querySelector('.collage-photo-slot-item[data-slot-index="' + i + '"]');
    if (!li) return;
    const ti = li.querySelector('.collage-photo-slot-thumb img');
    if (ti && photoSrcs[i]) ti.src = photoSrcs[i];
    const sp = li.querySelector('.collage-photo-slot-upload span');
    if (sp && photoSrcs[i]) sp.textContent = 'Ändern';
  }

  function buildTextFields() {
    const host = document.getElementById('collage-poster-text-fields-' + sectionId);
    const textTab = root.querySelector('.collage-poster-tab-text');
    if (!host) return;
    if (!state.texts.length) {
      host.innerHTML = '';
      if (textTab) textTab.style.display = 'none';
      return;
    }
    if (textTab) textTab.style.display = '';
    host.innerHTML = '';
    state.texts.forEach(function (t, i) {
      const wrap = document.createElement('div'); wrap.className = 'collage-text-field';
      const row = document.createElement('div'); row.className = 'collage-text-row';
      const inp = document.createElement('input');
      inp.type = 'text'; inp.value = t.content; inp.maxLength = 60; inp.autocomplete = 'off';
      inp.addEventListener('input', function () {
        t.content = inp.value;
        const el = stage.querySelector('.text-slot[data-text-index="' + i + '"]');
        if (el) el.textContent = inp.value;
      });
      const col = document.createElement('input');
      col.type = 'color'; col.value = t.color || '#28292d';
      col.addEventListener('input', function () {
        t.color = col.value;
        const el = stage.querySelector('.text-slot[data-text-index="' + i + '"]');
        if (el) el.style.color = col.value;
      });
      row.appendChild(inp); row.appendChild(col);
      wrap.appendChild(row);
      host.appendChild(wrap);
    });
  }

  /* ===================================================================
   * Tabs / Größe / Farbe
   * =================================================================== */
  var formatDefaulted = false;
  function initTabSwitching() {
    const tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    const panels = ['layout__wrapper', 'text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        const target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          const el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (<=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  function initSizePicker() {
    const opts = root.querySelectorAll('.collage-poster-size-option');
    const variantInput = document.getElementById('collage-poster-variant-id-' + sectionId);
    const first = opts[0];
    if (first) {
      state.paper_size = first.dataset.size; state.variant_id = first.dataset.variantId;
      if (variantInput) variantInput.value = state.variant_id;
    }
    opts.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        opts.forEach(function (o) { o.classList.remove('current'); });
        opt.classList.add('current');
        state.paper_size = opt.dataset.size; state.variant_id = opt.dataset.variantId;
        if (variantInput) variantInput.value = state.variant_id;
        const priceStr = opt.dataset.price || '';
        const priceEl = root.querySelector('.bottom__controls .variant-price');
        if (priceEl && priceStr) { priceEl.textContent = priceStr + ' €'; priceEl.dataset.price = priceStr; }
      });
    });
  }

  function initColorPicker() {
    const links = root.querySelectorAll('.color-picker-section .blanket-color-picker .wrap a');
    const customInput = document.getElementById('collage-poster-custom-color-' + sectionId);
    function apply(hex) {
      state.bgColor = hex; state.design_color = hex;
      if (currentGrid) currentGrid.style.setProperty('--blanket-color', hex);
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (link.classList.contains('custom')) return;
        e.preventDefault();
        links.forEach(function (l) { l.classList.remove('current'); });
        link.classList.add('current');
        const c = link.getAttribute('data-color'); if (c) apply(c);
      });
    });
    if (customInput) {
      let deb;
      customInput.addEventListener('input', function () {
        const self = this; const customLink = self.closest('a');
        if (customLink) { links.forEach(function (l) { l.classList.remove('current'); }); customLink.classList.add('current'); }
        clearTimeout(deb); deb = setTimeout(function () { apply(self.value); }, 120);
      });
    }
  }
  function syncColorPicker() {
    if (!root) return;
    const links = root.querySelectorAll('.color-picker-section .blanket-color-picker .wrap a');
    links.forEach(function (a) {
      a.classList.remove('current');
      const c = a.getAttribute('data-color');
      if (c && c.toLowerCase() === String(state.bgColor).toLowerCase()) a.classList.add('current');
    });
  }

  /* === Muster-Farben (erweiterbar): pro Layout-Farbe ein eigener Picker ===
   * Datenquelle/-senke = activeLayout.overlay.colors[] (durch deepCloneLayout pro
   * Layout frisch → Reset beim Wechsel automatisch). Plain-Layouts: nichts, der
   * einzelne Deckenfarbe-Picker (.color-picker-section) bleibt sichtbar.
   * N Picker = colors.length → 4-Farb-Muster später ohne UI-Umbau. */
  function _hexToRgb(hex) {
    let h = String(hex).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }
  function _colorDist(h1, h2) {
    const a = _hexToRgb(h1), b = _hexToRgb(h2);
    return Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2));
  }
  // Muster-Farben liegen je nach Layout auf overlay (Karo/Streifen/Quilt) ODER underlay (Colorblock/Plaid).
  function patternHolder() {
    if (activeLayout.overlay && activeLayout.overlay.colors) return activeLayout.overlay;
    if (activeLayout.underlay && activeLayout.underlay.colors) return activeLayout.underlay;
    if (activeLayout.frame && activeLayout.frame.colors) return activeLayout.frame;   // Doppelrahmen: Außen/Innen
    return null;
  }
  function updateContrastHint() {
    const sec = root && root.querySelector('.pattern-color-picker-section');
    if (!sec) return;
    const hint = sec.querySelector('.pattern-contrast-hint');
    const holder = patternHolder();
    const cols = (holder && holder.colors) || [];
    let tooClose = false;
    if (cols.length === 2 && _colorDist(cols[0], cols[1]) < 32) tooClose = true;   // Hinweis nur bei genau 2 Farben
    if (hint) hint.style.display = tooClose ? '' : 'none';
  }
  function buildPatternColorPickers() {
    if (!root) return;
    const sec = root.querySelector('.pattern-color-picker-section');
    const single = root.querySelector('.color-picker-section');
    if (!sec) return;
    const holder = patternHolder();
    const cols = holder && holder.colors;
    if (!cols) {                                  // Plain-Layout → einzelner Deckenfarbe-Picker
      sec.style.display = 'none'; sec.innerHTML = '';
      if (single) single.style.display = '';
      return;
    }
    if (single) single.style.display = 'none';    // Muster-Layout → einzelnen Picker verstecken
    sec.style.display = '';
    sec.innerHTML = '';

    const head = document.createElement('p');
    const singleHead = single && single.querySelector('p');   // gleiche Beschriftung wie der normale Picker (Konsistenz)
    head.textContent = (singleHead && singleHead.textContent.trim()) || 'Deckenfarbe';
    sec.appendChild(head);

    // Tab-Leiste „Farbe 1 / Farbe 2 …" nebeneinander (segmentiert, Optik wie Editor-Tabs, kompakt)
    const tabs = document.createElement('div'); tabs.className = 'pattern-color-tabs';
    const grids = document.createElement('div'); grids.className = 'pattern-color-grids';
    const tabEls = [], gridWraps = [];
    function showTab(active) {
      tabEls.forEach(function (t, i) { t.classList.toggle('current', i === active); });
      gridWraps.forEach(function (g, i) { g.style.display = (i === active) ? '' : 'none'; });
    }

    cols.forEach(function (col, idx) {
      const tab = document.createElement('a');
      tab.href = '#'; tab.textContent = (holder.labels && holder.labels[idx]) || ('Farbe ' + (idx + 1));
      tab.addEventListener('click', function (e) { e.preventDefault(); showTab(idx); });
      tabs.appendChild(tab); tabEls.push(tab);

      const gw = document.createElement('div'); gw.className = 'pattern-color-grid-wrap';
      const grid = document.createElement('div');
      grid.className = 'color-options-grid blanket-color-picker pattern-color-grid';
      function clearCurrent() { grid.querySelectorAll('.wrap a').forEach(function (l) { l.classList.remove('current'); }); }

      BLANKET_COLORS.forEach(function (hex) {
        const wrap = document.createElement('div'); wrap.className = 'wrap';
        const a = document.createElement('a'); a.href = '#'; a.setAttribute('data-color', hex);
        if (hex.toLowerCase() === String(col).toLowerCase()) a.classList.add('current');
        const sp = document.createElement('span'); sp.className = 'color'; sp.style.backgroundColor = hex;
        a.appendChild(sp); wrap.appendChild(a); grid.appendChild(wrap);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          clearCurrent(); a.classList.add('current');
          holder.colors[idx] = hex;
          renderStage(); updateContrastHint();
        });
      });

      // Custom-Farbrad (gleiche Optik wie Deckenfarbe-Picker)
      const cwrap = document.createElement('div'); cwrap.className = 'wrap custom-color-wrap';
      const ca = document.createElement('a'); ca.href = '#'; ca.className = 'custom';
      const csp = document.createElement('span'); csp.className = 'color';
      const clab = document.createElement('label');
      const cinp = document.createElement('input');
      cinp.type = 'color'; cinp.className = 'custom-color-picker';
      cinp.id = 'collage-poster-pattern-color-' + sectionId + '-' + idx; cinp.value = col;
      clab.setAttribute('for', cinp.id);
      clab.appendChild(cinp); csp.appendChild(clab); ca.appendChild(csp); cwrap.appendChild(ca); grid.appendChild(cwrap);
      let deb;
      cinp.addEventListener('input', function () {
        clearCurrent(); ca.classList.add('current');
        const v = cinp.value;
        clearTimeout(deb); deb = setTimeout(function () {
          holder.colors[idx] = v; renderStage(); updateContrastHint();
        }, 120);
      });

      gw.appendChild(grid); grids.appendChild(gw); gridWraps.push(gw);
    });

    if (cols.length < 2) tabs.style.display = 'none';   // 1-Farb-Muster (Quilt): keine Tab-Leiste nötig
    sec.appendChild(tabs);
    sec.appendChild(grids);
    showTab(0);

    const hint = document.createElement('p');
    hint.className = 'collage-tab-hint pattern-contrast-hint';
    hint.textContent = 'Die beiden Farben sind sehr ähnlich — kaum Unterschied sichtbar.';
    hint.style.display = 'none';
    sec.appendChild(hint);
    updateContrastHint();
  }

  /* ===================================================================
   * Cart-Add
   * =================================================================== */
  async function handleCartAdd() {
    const cartBtn = document.getElementById('collage-poster-cart-btn-' + sectionId);
    if (!state.variant_id) { alert('Bitte Größe wählen'); return; }
    const total = totalSlots(activeLayout);
    let uploaded = 0; for (let i = 0; i < total; i++) if (slotData[i] && slotData[i].user_image_url) uploaded++;
    if (uploaded === 0) { alert('Bitte lade mindestens 1 eigenes Foto hoch.'); return; }
    cartBtn.disabled = true; cartBtn.textContent = 'Wird vorbereitet…';
    try {
      const jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
      const photoSlotsOut = {};
      activeLayout.photos.forEach(function (ph, i) {
        photoSlotsOut['p' + (i + 1)] = {
          user_image_url: (slotData[i] && slotData[i].user_image_url) || '',
          crop: (slotData[i] && slotData[i].crop) || null,
          pos: (ph.x != null) ? { x: ph.x, y: ph.y, w: ph.w, h: ph.h, rot: ph.rot || 0 } : null
        };
      });
      let bi = activeLayout.photos.length;
      (activeLayout.bars || []).forEach(function (bar) {
        for (let k = 0; k < (bar.cols || 1); k++) {
          photoSlotsOut['p' + (bi + 1)] = {
            user_image_url: (slotData[bi] && slotData[bi].user_image_url) || '',
            crop: (slotData[bi] && slotData[bi].crop) || null, pos: null
          };
          bi++;
        }
      });
      const textSlotsOut = state.texts.map(function (t) { return { content: t.content, color: t.color, x: t.x, y: t.y }; });
      var _d = parsePosterDim(state.paper_size); var _lo = Math.min(_d.w, _d.h), _hi = Math.max(_d.w, _d.h);
      const payload = {
        job_id: jobId, product: 'collageposter', layout_id: layoutId,
        paper_size: state.paper_size, product_type: state.product_type, variant_id: state.variant_id, aspect: activeLayout.aspect,
        photo_slots: photoSlotsOut, text_slots: textSlotsOut, design_color: state.design_color,
        print: { width: activeLayout._landscape ? _hi : _lo, height: activeLayout._landscape ? _lo : _hi, dpi: 300, orientation: activeLayout._landscape ? 'landscape' : 'portrait' }
      };
      // Muster-Layouts (overlay ODER underlay): kundengewählte Farben mitschicken (Array, beliebig lang).
      const _ph = patternHolder();
      if (_ph) payload.pattern_colors = _ph.colors.slice();

      // Render-Trigger (Phase 3): 404 ist OK → Fallback-URL.
      let printImageUrl = BACKEND_API_URL + '/api/v1/collageposter/data/' + jobId + '/';
      try {
        const renderResp = await fetch(BACKEND_API_URL + '/api/v1/collageposter/render/', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
        });
        if (renderResp.ok || renderResp.status === 202) {
          const rd = await renderResp.json().catch(function () { return {}; });
          printImageUrl = rd.print_image_url || printImageUrl;
        }
      } catch (e) { /* Backend Phase 3 evtl. noch nicht live */ }

      const props = {
        '_Collage Config JSON': JSON.stringify(payload),
        '_Layout': layoutId,
        '_print_image_url': printImageUrl,
        '_job_id': jobId,
        // Cart-Vorschau (PROJ-72): persistentes Komposit vom Render-Worker
        '_preview_image_url': BACKEND_API_URL + '/media/blanket_renders/' + jobId + '_cartpreview.jpg',
        '_Motiv': activeLayout.name,
        '_Product Type': state.product_type,
        '_Paper Size': state.paper_size,
      };
      if (state.frame_color && state.product_type && state.product_type.indexOf('Holzrahmen') !== -1) props['_Frame Color'] = state.frame_color;
      if (_ph) props['_Musterfarben'] = _ph.colors.join(', ');
      // Cart-Properties IMMER _-geprefixt -> im Warenkorb versteckt (nur Name/Preis/Variante sichtbar)
      state.texts.forEach(function (t, i) { if (t.content) props['_Text ' + (i + 1)] = t.content; });
      Object.keys(photoSlotsOut).forEach(function (k) {
        if (photoSlotsOut[k].user_image_url) props['_Foto ' + k.slice(1)] = photoSlotsOut[k].user_image_url;
      });

      // Sofort-Vorschau (PROJ-72): Schnappschuss der sichtbaren Stage in sessionStorage,
      // damit der Warenkorb das Motiv sofort zeigt. Helper ist fail-soft (max 2,5s),
      // der Kauf wird nie blockiert.
      await (window.kaSofortVorschau ? window.kaSofortVorschau(stage, jobId) : Promise.resolve());

      const cartResp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] }),
      });
      if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

      var _cd = null; try { _cd = await cartResp.json(); } catch (e) { /* body optional */ }
      if (_cd && window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(_cd);
      // Citymap-Pattern: /cart/add.js-Antwort (Line-Item) als detail.cart — EIN Read.
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: _cd } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
      else window.location.href = '/cart';
    } catch (err) {
      console.error('[collage-poster] Cart-add failed', err);
      alert('Konnte nicht in den Warenkorb legen — ' + (err.message || 'Unbekannter Fehler'));
    } finally {
      cartBtn.disabled = false; cartBtn.textContent = 'In den Warenkorb';
    }
  }

  /* ===================================================================
   * Init
   * =================================================================== */
  function init() {
    root = document.querySelector('.collage-poster-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    layoutId = root.dataset.layoutId || 'vier-grid';
    try {
      var pj = document.getElementById('collage-poster-products-' + sectionId);
      if (pj) LAYOUT_PRODUCTS = JSON.parse(pj.textContent) || {};
    } catch (e) { LAYOUT_PRODUCTS = {}; }
    stage = document.getElementById('collage-poster-stage-' + sectionId);
    assets = { fleece: root.dataset.assetFleece, placeholder: root.dataset.assetPlaceholder };
    if (!getLayout(layoutId) || !isDeckeLayout(getLayout(layoutId))) {
      const firstDecke = LAYOUTS.filter(isDeckeLayout)[0];
      layoutId = (firstDecke || LAYOUTS[0]).id;
    }
    buildLayoutPicker();
    loadLayout(layoutId);
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();
    initColorPicker();
    const cartBtn = document.getElementById('collage-poster-cart-btn-' + sectionId);
    if (cartBtn) cartBtn.addEventListener('click', handleCartAdd);
  }


  /* ===================================================================
   * Poster-Format/Größe (Fotoposter-Schema) + Stage-Aspect (PROJ-13)
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) { return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ','); }
  function syncStageToSize() {
    if (!activeLayout || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var lo = Math.min(d.w, d.h), hi = Math.max(d.w, d.h);
    var aspect = activeLayout._landscape ? (hi + '/' + lo) : (lo + '/' + hi);
    if (activeLayout.aspect === aspect) return;
    activeLayout.aspect = aspect;
    if (stage) {
      stage.style.setProperty('--collage-aspect', aspect);
      stage.classList.toggle('is-landscape', !!activeLayout._landscape);
      stage.classList.toggle('is-portrait', !activeLayout._landscape);
    }
    renderStage();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var vi = document.getElementById('collage-poster-variant-id-' + sectionId);
    if (vi && state.variant_id) vi.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  /* Holzrahmen-Vorschau: bei Typ "Poster im Holzrahmen" Frame an der Stage ein. */
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');
    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) { f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none'; });
        root.querySelectorAll('.benefits-box').forEach(function (b) { b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none'; });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') || fmt.querySelector('.size__picker a.current') || fmt.querySelector('.size__picker a[data-size]');
        if (ziel) { fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); }); ziel.classList.add('current'); syncVariantFromSize(ziel); }
      });
    });
    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });
    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });
    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) { if (!activeSize.classList.contains('current')) activeSize.classList.add('current'); syncVariantFromSize(activeSize); }
    updateFramePreview();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
